window.FazendaRP = window.FazendaRP || {};
window.FazendaRP.Pages = window.FazendaRP.Pages || {};

window.FazendaRP.Pages.Relatorios = {
    // =================================================================================
    // NEW VISUAL STRUCTURE (Tabs: Visão Geral, DRE, Fluxo, Safra)
    // =================================================================================


    // State
    state: {
        activeTab: 'visao-geral',
        activeSubTab: null
    },

    init: function (container) {
        this.render(container);
    },

    render: function (container) {
        container.innerHTML = '';

        const style = document.createElement('style');
        style.innerHTML = `
            .relatorio-full-container { display:flex; flex-direction:column; height:100%; width:100%; background:white; border-radius:8px; overflow:hidden; box-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1); }
            .dre-wrapper { flex:1; overflow:auto; background:white; position:relative; width:100%; scrollbar-width: thin; }
            
            /* TABS */
            .tabs-header { display:flex; background:#f8fafc; border-bottom:1px solid #e2e8f0; padding:0 20px; gap:20px; }
            .tab-btn { 
                padding: 15px 5px; 
                background:transparent; 
                border:none; 
                border-bottom: 2px solid transparent; 
                font-weight:600; color:#64748b; 
                cursor:pointer; font-size:0.9rem; 
                transition:all 0.2s;
            }
            .tab-btn:hover { color:#334155; }
            .tab-btn.active { color:#3b82f6; border-bottom-color:#3b82f6; }

            /* SUBMENU PILLS */
            .submenu-pills { display:flex; gap:10px; align-items:center; }
            .pill-btn {
                padding: 6px 14px;
                border-radius: 20px;
                background: #f1f5f9;
                color: #64748b;
                font-size: 0.8rem;
                font-weight: 600;
                border: 1px solid transparent;
                cursor: pointer;
            }
            .pill-btn:hover { background: #e2e8f0; }
            .pill-btn.active { background: #eff6ff; color: #3b82f6; border-color: #bfdbfe; }

            /* CONTROLS */
            .controls-bar { padding: 12px 20px; background: white; border-bottom: 1px solid #f1f5f9; display:flex; justify-content:space-between; align-items:center; gap:15px; flex-wrap:wrap; min-height:60px; }
            
            /* COMMON TABLES & SCROLL */
            .dre-table { width:100%; min-width:1500px; border-collapse:separate; border-spacing:0; font-family:'Inter', sans-serif; font-size:0.85rem; color:#334155; }
            .dre-table th { position:sticky; top:0; background:#f8fafc; z-index:30; padding:12px 16px; text-align:right; border-bottom:1px solid #cbd5e1; font-weight:600; color:#64748b; text-transform:uppercase; font-size:0.7rem; letter-spacing: 0.05em; white-space:nowrap; }
            .dre-table td { padding:12px 16px; border-bottom:1px solid #f1f5f9; text-align:right; white-space:nowrap; font-feature-settings: "tnum"; }
            .col-sticky { position:sticky; z-index:20; background-color: inherit; }
            .col-desc  { left:0; text-align:left !important; min-width:320px; max-width:320px; border-right:1px solid #f1f5f9; }
            .col-total { left:320px; width:120px; font-weight:600; border-right:1px solid #f1f5f9; }
            .col-av    { left:440px; width:80px; font-size:0.75rem; color:#64748b; border-right: 2px solid #cbd5e1 !important; }
            thead .col-sticky { background-color: #f8fafc; z-index: 40; border-bottom: 2px solid #cbd5e1; }
            .row-header { background-color:#f8fafc; font-weight:700; color:#1e293b; }
            .row-subtotal { background-color:#f1f5f9; font-weight:700; color:#334155; }
            .row-total { background-color:#e2e8f0; font-weight:800; color:#0f172a; border-top: 2px solid #cbd5e1; border-bottom: 2px solid #cbd5e1; }
            .row-receita { color: #166534; }
            .row-receita.row-total { background-color: #dcfce7; border-color: #86efac; }
            .row-despesa { color: #991b1b; }
            .row-despesa.row-total { background-color: #fee2e2; border-color: #fca5a5; }
            .row-resultado { background-color: #f8fafc; font-size: 1rem; border-top: 3px solid #64748b; }
            .result-positive { color: #15803d; background-color: #f0fdf4; }
            .result-negative { color: #b91c1c; background-color: #fef2f2; }
            tr:hover td { background-color: #fffbeb !important; cursor: default; }
        `;
        container.appendChild(style);

        container.innerHTML += `
            <div class="relatorio-full-container">
                <!-- TABS HEADER -->
                <div class="tabs-header">
                    <button class="tab-btn ${this.state.activeTab === 'visao-geral' ? 'active' : ''}" onclick="window.FazendaRP.Pages.Relatorios.switchTab('visao-geral')">Visão Geral</button>
                    <button class="tab-btn ${this.state.activeTab === 'dre' ? 'active' : ''}" onclick="window.FazendaRP.Pages.Relatorios.switchTab('dre')">DRE</button>
                    <button class="tab-btn ${this.state.activeTab === 'fluxo' ? 'active' : ''}" onclick="window.FazendaRP.Pages.Relatorios.switchTab('fluxo')">Fluxo de Caixa</button>
                    <button class="tab-btn ${this.state.activeTab === 'balanco' ? 'active' : ''}" onclick="window.FazendaRP.Pages.Relatorios.switchTab('balanco')">Balanço Patrimonial</button>
                    <button class="tab-btn ${this.state.activeTab === 'safra' ? 'active' : ''}" onclick="window.FazendaRP.Pages.Relatorios.switchTab('safra')">Resultados por Safra</button>
                    <button class="tab-btn ${this.state.activeTab === 'bi-explorer' ? 'active' : ''}" onclick="window.FazendaRP.Pages.Relatorios.switchTab('bi-explorer')" style="color: #3b82f6;"><i class="fas fa-magic"></i> Explorador BI</button>
                </div>

                <!-- DYNAMIC CONTROLS -->
                <div id="rel-controls-bar" class="controls-bar">
                    <!-- Injected by renderControls -->
                </div>

                <!-- CONTENT AREA -->
                <div id="relatorio-content" class="dre-wrapper">
                    <!-- Report Table/Chart Goes Here -->
                </div>
            </div>
        `;

        this.switchTab(this.state.activeTab, true); // Force initial render
    },

    switchTab: function (tabName, force = false) {
        if (this.state.activeTab === tabName && !force) return;
        this.state.activeTab = tabName;
        this.state.activeSubTab = null; // Reset sub-tab on main tab switch

        // Update UI Tabs
        document.querySelectorAll('.tab-btn').forEach(b => {
            b.classList.toggle('active',
                b.textContent.toLowerCase().includes(tabName.replace('-', ' ')) ||
                (tabName === 'fluxo' && b.textContent.includes('Fluxo')) ||
                (tabName === 'safra' && b.textContent.includes('Safra')) ||
                (tabName === 'balanco' && b.textContent.includes('Balanço'))
            );
        });

        // Set Default Subtabs
        if (tabName === 'dre') this.state.activeSubTab = 'dre-gerencial';
        if (tabName === 'fluxo') this.state.activeSubTab = 'fluxo-mensal';

        this.renderControls();
        this.runReportLogic();
    },

    switchSubTab: function (subTabName) {
        this.state.activeSubTab = subTabName;
        this.renderControls(); // Re-render to update active pill
        this.runReportLogic();
    },

    renderControls: function () {
        const bar = document.getElementById('rel-controls-bar');
        if (!bar) return;
        bar.innerHTML = '';

        const tab = this.state.activeTab;
        const sub = this.state.activeSubTab;

        // 1. LEFT SIDE: Sub-Tabs (Pills)
        const leftDiv = document.createElement('div');
        leftDiv.className = 'submenu-pills';

        if (tab === 'visao-geral') {
            leftDiv.innerHTML = '<span style="font-weight:700; color:#334155;">Dashboard Financeiro</span>';
        }
        else if (tab === 'balanco') {
            leftDiv.innerHTML = '<span style="font-weight:700; color:#10b981;">Balanço Patrimonial Gerencial</span>';
        }
        else if (tab === 'dre') {
            leftDiv.innerHTML = `
                <button class="pill-btn ${sub === 'dre-gerencial' ? 'active' : ''}" onclick="window.FazendaRP.Pages.Relatorios.switchSubTab('dre-gerencial')">DRE Gerencial (Mensal)</button>
                <button class="pill-btn ${sub === 'dre-auditoria' ? 'active' : ''}" onclick="window.FazendaRP.Pages.Relatorios.switchSubTab('dre-auditoria')">Auditoria</button>
                <button class="pill-btn ${sub === 'comparativo-anual' ? 'active' : ''}" onclick="window.FazendaRP.Pages.Relatorios.switchSubTab('comparativo-anual')">Comparativo Anual</button>
            `;
        }
        else if (tab === 'fluxo') {
            leftDiv.innerHTML = `
                <button class="pill-btn ${sub === 'fluxo-mensal' ? 'active' : ''}" onclick="window.FazendaRP.Pages.Relatorios.switchSubTab('fluxo-mensal')">Fluxo Mensal (Realizado)</button>
                <button class="pill-btn ${sub === 'fluxo-diario' ? 'active' : ''}" onclick="window.FazendaRP.Pages.Relatorios.switchSubTab('fluxo-diario')">Fluxo Diário (Previsão)</button>
                <button class="pill-btn ${sub === 'livro-caixa' ? 'active' : ''}" onclick="window.FazendaRP.Pages.Relatorios.switchSubTab('livro-caixa')">Livro Caixa</button>
                <button class="pill-btn ${sub === 'real-vs-proj' ? 'active' : ''}" onclick="window.FazendaRP.Pages.Relatorios.switchSubTab('real-vs-proj')">Realizado vs Projetado</button>
            `;
        }
        else if (tab === 'safra') {
            leftDiv.innerHTML = '<span style="font-weight:700; color:#334155;">Análise de Safra</span>';
        }

        bar.appendChild(leftDiv);

        // 2. RIGHT SIDE: Filters
        const rightDiv = document.createElement('div');
        rightDiv.style.display = 'flex';
        rightDiv.style.gap = '10px';
        rightDiv.style.alignItems = 'center';

        // Helper to check visibility
        const showYear = ['dre-gerencial', 'dre-auditoria', 'comparativo-anual', 'fluxo-mensal'].includes(sub) || (tab === 'dre' && !sub);
        const showMonthRange = ['real-vs-proj'].includes(sub);
        const showDates = ['livro-caixa', 'fluxo-diario'].includes(sub);
        const showAccount = ['livro-caixa', 'fluxo-diario'].includes(sub);
        const showSafra = tab === 'safra';

        // Filter: Year
        if (showYear) {
            rightDiv.innerHTML += `
               <label style="font-size:0.8rem; font-weight:600; color:#64748b;">Ano:</label>
               <select id="sel-ano-rel" class="form-control" style="width:100px; padding:6px;" onchange="window.FazendaRP.Pages.Relatorios.runReportLogic()">
                    <option value="2026">2026</option>
                    <option value="2025" selected>2025</option>
                    <option value="2024">2024</option>
                    <option value="2023">2023</option>
               </select>
            `;
            // Checkbox Hide Zeros
            if (['dre-gerencial', 'fluxo-mensal'].includes(sub)) {
                rightDiv.innerHTML += `
                    <label style="display:flex; align-items:center; gap:5px; margin-left:10px; font-size:0.8rem; cursor:pointer;">
                        <input type="checkbox" id="chk-ocultar-zeros" checked onchange="window.FazendaRP.Pages.Relatorios.runReportLogic()"> <span style="color:#64748b;">Ocultar Zeros</span>
                    </label>
                `;
            }
        }

        // Filter: Dynamic Month Range (Real vs Proj)
        if (showMonthRange) {
            const today = new Date();
            const startM = new Date(today.getFullYear(), 0, 1).toISOString().slice(0, 7); // Jan Current Year
            const endM = new Date(today.getFullYear(), 11, 1).toISOString().slice(0, 7); // Dec Current Year

            rightDiv.innerHTML += `
               <div style="display:flex; align-items:center; gap:5px;">
                   <label style="font-size:0.8rem; font-weight:600; color:#64748b;">De:</label>
                   <input type="month" id="rel-mes-inicio" value="${startM}" class="form-control" style="padding:6px;">
                   <label style="font-size:0.8rem; font-weight:600; color:#64748b;">Até:</label>
                   <input type="month" id="rel-mes-fim" value="${endM}" class="form-control" style="padding:6px;">
                   <button class="btn btn-primary" onclick="window.FazendaRP.Pages.Relatorios.runReportLogic()" style="padding:6px 10px;">
                        <i class="fas fa-sync-alt"></i>
                   </button>
               </div>
            `;
        }

        // Filter: Date Range
        if (showDates) {
            const today = new Date();
            const startStr = new Date(today.getFullYear(), today.getMonth(), 1).toISOString().split('T')[0];
            const endStr = new Date(today.getFullYear(), today.getMonth() + 1, 0).toISOString().split('T')[0];

            // Container for dates
            const dateSpan = document.createElement('span');
            dateSpan.style.display = 'flex';
            dateSpan.style.gap = '5px';
            dateSpan.innerHTML = `
                <input type="date" id="rel-inicio" value="${startStr}" class="form-control" style="padding:6px;">
                <input type="date" id="rel-fim" value="${endStr}" class="form-control" style="padding:6px;">
            `;
            rightDiv.appendChild(dateSpan);

            rightDiv.innerHTML += `
                <button class="btn btn-primary" onclick="window.FazendaRP.Pages.Relatorios.runReportLogic()" style="padding:6px 10px;">
                    <i class="fas fa-sync-alt"></i>
                </button>
            `;
        }

        // Filter: Account (Async Load)
        if (showAccount) {
            const accContainer = document.createElement('div');
            accContainer.id = 'box-conta-filtro';
            // We need to render the select. Let's use existing helper if possible, or create a placeholder.
            // Helper `loadContasSelect` appends to container.
            // It might be async.
            rightDiv.insertBefore(accContainer, rightDiv.firstChild);
            if (this.loadContasSelect) this.loadContasSelect(accContainer);
        }

        // Filter: Safra
        if (showSafra) {
            const safraContainer = document.createElement('div');
            safraContainer.id = 'box-safra-placeholder';
            rightDiv.appendChild(safraContainer);
            if (this.loadSafrasSelect) this.loadSafrasSelect(safraContainer, true);
        }

        // Print
        const btnPrint = document.createElement('button');
        btnPrint.className = 'btn-report';
        btnPrint.onclick = () => window.print();
        btnPrint.style.cssText = 'padding:6px 12px; margin-left:10px;';
        btnPrint.innerHTML = '<i class="fas fa-print"></i>';
        rightDiv.appendChild(btnPrint);

        bar.appendChild(rightDiv);
    },

    runReportLogic: function () {
        const tab = this.state.activeTab;
        const sub = this.state.activeSubTab;

        if (tab === 'visao-geral') {
            document.getElementById('relatorio-content').innerHTML = '<div style="padding:50px; text-align:center; color:#94a3b8;"><i class="fas fa-chart-pie fa-3x"></i><p>Dashboard Geral em desenvolvimento.</p></div>';
        }
        else if (tab === 'balanco') {
            if (window.FazendaRP.Pages.Relatorios.Balanco) {
                window.FazendaRP.Pages.Relatorios.Balanco.render(document.getElementById('relatorio-content'));
            } else {
                document.getElementById('relatorio-content').innerHTML = '<div style="padding:20px; color:red;">Módulo Balanço não carregado.</div>';
            }
        }
        else if (tab === 'dre') {
            if (sub === 'dre-gerencial') this.gerarDREAnalitico();
            else if (sub === 'dre-auditoria') this.gerarDREAuditoria();
            else if (sub === 'comparativo-anual') {
                const ano = document.getElementById('sel-ano-rel') ? document.getElementById('sel-ano-rel').value : new Date().getFullYear();
                this.gerarComparativoAnual(ano);
            }
        }
        else if (tab === 'fluxo') {
            const ano = document.getElementById('sel-ano-rel') ? document.getElementById('sel-ano-rel').value : new Date().getFullYear();
            const inicio = document.getElementById('rel-inicio')?.value;
            const fim = document.getElementById('rel-fim')?.value;
            const contaId = document.getElementById('sel-conta-filtro')?.value;

            if (sub === 'fluxo-mensal') this.gerarFluxoMensal(ano);
            else if (sub === 'real-vs-proj') {
                this.injectChartJS();
                setTimeout(() => this.gerarComparativoRealProj(), 100);
            }
            else if (sub === 'fluxo-diario') {
                if (!inicio || !fim) { alert('Selecione o período'); return; }
                this.injectChartJS();
                this.gerarFluxoCaixa(inicio, fim, contaId); // Daily
            }
            else if (sub === 'livro-caixa') {
                if (!inicio || !fim) { alert('Selecione o período'); return; }
                this.gerarLivroCaixa(inicio, fim, contaId);
            }
        }
        else if (tab === 'safra') {
            const safraId = document.getElementById('sel-safra-filtro')?.value;
            if (safraId) this.gerarResultadoSafra(safraId);
            else document.getElementById('relatorio-content').innerHTML = '<div style="padding:50px; text-align:center;">Selecione uma Safra</div>';
        }
        else if (tab === 'bi-explorer') {
            const contentArea = document.getElementById('relatorio-content');
            if (this.BIExplorer && this.BIExplorer.render) {
                this.BIExplorer.render(contentArea);
            } else {
                contentArea.innerHTML = '<div style="padding:50px; text-align:center; color:#ef4444;"><i class="fas fa-exclamation-triangle"></i><p>Erro: Módulo BI Explorer não carregado.</p></div>';
            }
        }
    },
    parseCurrency: function (v) {
        if (typeof v === 'number') return v;
        if (!v) return 0;
        let str = String(v).trim();
        str = str.replace(/[^\d.,-]/g, '');
        if (str.includes(',') && !str.includes('.')) {
            str = str.replace(',', '.');
        } else if (str.includes('.') && str.includes(',')) {
            str = str.replace(/\./g, '').replace(',', '.');
        }
        return parseFloat(str) || 0;
    },

    injectChartJS: function () {
        if (document.getElementById('chartjs-script')) return;
        const s1 = document.createElement('script');
        s1.id = 'chartjs-script';
        s1.src = 'https://cdn.jsdelivr.net/npm/chart.js@4.4.1/dist/chart.umd.min.js';
        document.head.appendChild(s1);

        // Plugin annotation (opcional)
        s1.onload = () => {
            // Optional plugin load
        };
    },

    loadContasSelect: async function (targetContainer) {
        try {
            // Fetch accounts
            const { data: contas } = await window.FazendaRP.supabase.from('financeiro_contas').select('id, nome').order('nome');

            // Style the container (flex row like Safra)
            targetContainer.style.display = 'flex';
            targetContainer.style.alignItems = 'center';
            targetContainer.style.gap = '5px';

            // Populate
            targetContainer.innerHTML = `
                <label style="font-size:0.8rem; font-weight:600; color:#64748b;">Conta:</label>
                <select id="sel-conta-filtro" class="form-control" style="min-width:150px; padding:6px;" onchange="window.FazendaRP.Pages.Relatorios.runReportLogic()">
                    <option value="">Todas</option>
                    ${(contas || []).map(c => `<option value="${c.id}">${c.nome}</option>`).join('')}
                </select>
            `;

        } catch (e) { console.error('Erro Contas', e); }
    },

    loadSafrasSelect: async function (targetContainer, appendDirect = false) {
        console.log('loadSafrasSelect called', { appendDirect });

        // 1. RE-ACQUIRE CONTAINER (Fix for Zombie Container)
        let actualContainer = targetContainer;
        if (appendDirect && targetContainer && targetContainer.id) {
            const fresh = document.getElementById(targetContainer.id);
            if (fresh) actualContainer = fresh;
            console.log('Container Refreshed:', { old: targetContainer, new: fresh, match: targetContainer === fresh });
        }

        try {
            // Debug: Indicate loading
            if (appendDirect && actualContainer) actualContainer.innerHTML = '<span style="font-size:0.8rem; color:#64748b;"><i class="fas fa-circle-notch fa-spin"></i> Carregando safras...</span>';

            console.log('Fetching safras from Supabase...');
            const { data: safras, error } = await window.FazendaRP.supabase.from('safras').select('id, descricao, ano').order('ano', { ascending: false });
            console.log('Fetch result:', { safras, error });

            if (error) {
                console.error('Erro fetching safras:', error);
                if (appendDirect && actualContainer) actualContainer.innerHTML = '<span style="color:red; font-size:0.8rem;">Erro ao carregar safras</span>';
                return;
            }

            if (!safras || safras.length === 0) {
                console.warn('Nenhuma safra retornada.');
                if (appendDirect && actualContainer) actualContainer.innerHTML = '<span style="color:orange; font-size:0.8rem;">Nenhuma safra encontrada</span>';
                return;
            }

            let html = `
               <div id="box-safra-filtro" style="display:flex; align-items:center; gap:5px;">
                   <label style="font-size:0.8rem; font-weight:600; color:#64748b;">Safra:</label>
                   <select id="sel-safra-filtro" class="form-control" style="min-width:180px; padding:6px;" onchange="window.FazendaRP.Pages.Relatorios.runReportLogic()">
                       ${safras.map(s => `<option value="${s.id}">${s.descricao} (${s.ano})</option>`).join('')}
                   </select>
               </div>
           `;

            console.log('Updating DOM with Safras...');
            if (appendDirect) {
                if (actualContainer) actualContainer.innerHTML = html;
            } else {
                if (document.getElementById('box-safra-filtro')) return;
                const div = document.createElement('div');
                div.innerHTML = html;
                if (actualContainer) actualContainer.appendChild(div.firstElementChild);
            }

            // Trigger report only if Safra tab is active
            if (this.state.activeTab === 'safra') {
                // Slight delay to ensure DOM is ready
                setTimeout(() => {
                    console.log('Triggering runReportLogic from loadSafrasSelect');
                    this.runReportLogic();
                }, 200);
            }

        } catch (e) {
            console.error('Erro Safras Exception:', e);
            if (appendDirect && actualContainer) actualContainer.innerHTML = `<span style="color:red;">Erro: ${e.message}</span>`;
        }
    },


    // ============================================
    // 1. DRE GERENCIAL (MENSAL - EXPANSÍVEL)
    // ============================================
    gerarDREAnalitico: async function () {
        const area = document.getElementById('relatorio-content');
        area.innerHTML = '<div style="display:flex; height:100%; align-items:center; justify-content:center; color:#94a3b8;"><div style="text-align:center"><i class="fas fa-spinner fa-spin fa-2x"></i><p style="margin-top:10px">Gerando DRE Gerencial...</p></div></div>';

        const ano = parseInt(document.getElementById('sel-ano-rel').value);
        const ocultarZeros = document.getElementById('chk-ocultar-zeros') ? document.getElementById('chk-ocultar-zeros').checked : false;

        try {
            // 1. Fetch Data
            const { data: planoContas } = await window.FazendaRP.supabase.from('financeiro_plano_contas').select('*').order('codigo');

            const { data: lancs } = await window.FazendaRP.supabase.from('financeiro_lancamentos')
                .select('*, parceiros(nome)')
                .neq('status', 'Cancelado')
                // Optimization: Fetch slightly wider range to handle timezone/midnight edge cases
                .gte('data_vencimento', `${ano - 1}-01-01`)
                .lte('data_vencimento', `${ano + 1}-12-31`);

            // 2. Setup Map
            const contaMap = {};
            planoContas.forEach(c => {
                if (c.codigo) contaMap[c.codigo] = { ...c, total: 0, mensal: new Array(12).fill(0), itens: [] };
            });

            const parseCurrency = (v) => { // Duplicated helper, could be utility
                if (typeof v === 'number') return v;
                if (!v) return 0;
                let str = String(v).replace(/[^\d.,-]/g, '');
                if (str.includes(',') && !str.includes('.')) str = str.replace(',', '.');
                else if (str.includes('.') && str.includes(',')) str = str.replace(/\./g, '').replace(',', '.');
                return parseFloat(str) || 0;
            };

            // 2b. Find Special Accounts
            const findCode = (term, def) => {
                const f = planoContas.find(c => c.nome && c.nome.toLowerCase().includes(term.toLowerCase()));
                return f ? f.codigo : def;
            };
            const codeJuros = findCode('Juros', '2.4.1');
            const codeDesconto = findCode('Descontos Obtidos', '3.1.1');

            // 3. Process
            const processar = (catRaw, valRaw, dataOp, l, itemDesc) => {
                if (!catRaw || !dataOp) return;
                const d = new Date(dataOp);
                // Fix Timezone
                const userTimezoneOffset = d.getTimezoneOffset() * 60000;
                const correctedDate = new Date(d.getTime() + userTimezoneOffset);
                const y = correctedDate.getFullYear();
                if (y !== ano) return;
                const mIdx = correctedDate.getMonth();

                let catKey = String(catRaw).split(' - ')[0].trim();
                let conta = contaMap[catKey];
                if (!conta) {
                    const m = planoContas.find(c => c.id == catKey || c.nome == catKey);
                    if (m) conta = contaMap[m.codigo];
                }

                if (conta) {
                    let valor = parseFloat(valRaw) || 0;
                    const tipoOp = l.tipo;

                    // FORCE SIGNS
                    if (conta.codigo === codeDesconto) {
                        valor = Math.abs(valor);
                    } else if (conta.codigo === codeJuros) {
                        valor = -Math.abs(valor);
                    } else {
                        if (tipoOp && (tipoOp.toLowerCase().includes('despesa') || tipoOp.toLowerCase().includes('saída'))) {
                            valor = -Math.abs(valor);
                        } else {
                            valor = Math.abs(valor);
                        }
                    }

                    conta.total += valor;
                    conta.mensal[mIdx] += valor;

                    // Detail
                    conta.itens.push({
                        data: dataOp,
                        doc: l.num_doc || '-',
                        desc: itemDesc || l.descricao,
                        parceiro: (l.parceiros && l.parceiros.nome) ? l.parceiros.nome : '-',
                        valor: valor
                    });

                    // Parents
                    let parts = conta.codigo.split('.');
                    while (parts.length > 1) {
                        parts.pop();
                        let pai = contaMap[parts.join('.')];
                        if (pai) {
                            pai.total += valor;
                            pai.mensal[mIdx] += valor;
                        }
                    }
                }
            };

            lancs.forEach(l => {
                const dataRef = l.data_emissao || l.data_vencimento;
                let det = l.detalhes;
                if (typeof det === 'string') try { det = JSON.parse(det) } catch (e) { }

                const itens = det?.itens || [];

                if (itens.length > 0 && itens.some(i => i.categoria)) {
                    itens.forEach(i => {
                        const iVal = i.total || i.valor_total || (i.quantidade * i.valor_unit);
                        processar(i.categoria, iVal, dataRef, l, i.nome || i.descricao || `Item de ${l.descricao}`);
                    });

                    const juros = det?.juros || 0;
                    const desconto = det?.desconto || 0;
                    if (juros > 0) processar(codeJuros, juros, dataRef, l, 'Juros s/ ' + (l.descricao || 'Doc'));
                    if (desconto > 0) processar(codeDesconto, desconto, dataRef, l, 'Desconto s/ ' + (l.descricao || 'Doc'));

                } else {
                    const juros = det?.juros || 0;
                    const desconto = det?.desconto || 0;

                    // Calc Base properly
                    const valorBase = (parseFloat(l.valor) || 0) - (parseFloat(juros) || 0) + (parseFloat(desconto) || 0);

                    processar(l.categoria, valorBase, dataRef, l, l.descricao);
                    if (juros > 0) processar(codeJuros, juros, dataRef, l, 'Juros');
                    if (desconto > 0) processar(codeDesconto, desconto, dataRef, l, 'Desconto');
                }
            });

            // Recalculate Calculated Rows logic (EBITDA etc) for the *Header Buckets* if we want them perfect

            // 4. Render
            const buckets = { receitas: [], deducoes: [], custos: [], despesasOp: [], recNaoOp: [], despNaoOp: [], despFin: [], participacoes: [] };

            // Same bucket logic
            Object.values(contaMap).forEach(c => {
                if (!c.codigo) return;
                if (['1', '2', '3'].includes(c.codigo)) return;

                // Robust assignment
                if (c.codigo === codeDesconto) buckets.recNaoOp.push(c);
                else if (c.codigo === codeJuros) buckets.despFin.push(c);
                else if (c.codigo.startsWith('1')) buckets.receitas.push(c);
                else if (c.codigo.startsWith('2.6')) buckets.deducoes.push(c);
                else if (c.codigo.startsWith('2.1')) buckets.custos.push(c);
                else if (c.codigo.startsWith('2.2')) buckets.despesasOp.push(c);
                else if (c.codigo.startsWith('3')) buckets.recNaoOp.push(c);
                else if (c.codigo.startsWith('2.3')) buckets.despNaoOp.push(c);
                else if (c.codigo.startsWith('2.4')) buckets.despFin.push(c);
                else if (c.codigo.startsWith('2.5')) buckets.participacoes.push(c);
            });
            const sortFn = (a, b) => a.codigo.localeCompare(b.codigo, undefined, { numeric: true });
            Object.values(buckets).forEach(b => b.sort(sortFn));

            const fmt = (v) => v.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
            const fmtZero = (v) => (Math.abs(v) < 0.01) ? '-' : fmt(v);

            // ------------------------------------------
            // CALCULATE TOTALS FOR COMPUTED ROWS
            // ------------------------------------------
            const sumList = (list) => {
                const s = { total: 0, mensal: new Array(12).fill(0) };
                if (!list) return s;
                list.forEach(c => {
                    s.total += c.total;
                    c.mensal.forEach((v, i) => s.mensal[i] += v);
                });
                return s;
            };

            const totReceita = sumList(buckets.receitas);
            const totDeducoes = sumList(buckets.deducoes); // Should be negative
            const totCustos = sumList(buckets.custos);     // Should be negative
            const totDespOp = sumList(buckets.despesasOp); // Should be negative
            const totRecNaoOp = sumList(buckets.recNaoOp);
            const totDespNaoOp = sumList(buckets.despNaoOp);
            const totDespFin = sumList(buckets.despFin);

            // 1. RECEITA LÍQUIDA = Receita - Deducoes (Deducoes already negative?)
            // Logic check: expenses are forced negative in 'processar'. So we just SUM.
            const calcLiq = (a, b) => ({
                total: a.total + b.total,
                mensal: a.mensal.map((v, i) => v + b.mensal[i])
            });
            const totReceitaLiq = calcLiq(totReceita, totDeducoes);
            const totLucroBruto = calcLiq(totReceitaLiq, totCustos);
            const totResOp = calcLiq(totLucroBruto, totDespOp); // EBIT

            // EBITDA = Resultado Operacional - Depreciação (Actually + Depreciação because Depr is negative expense)
            // Find Depreciacao
            let valDepreciacao = { total: 0, mensal: new Array(12).fill(0) };
            const contaDepr = contaMap['2.2.1.7']; // Standard Code
            if (contaDepr) {
                valDepreciacao.total = -contaDepr.total; // Invert to Add Back
                valDepreciacao.mensal = contaDepr.mensal.map(v => -v);
            }
            const totEBITDA = calcLiq(totResOp, valDepreciacao);

            // Resultado Final
            let totFinal = { total: 0, mensal: new Array(12).fill(0) };
            [totResOp, totRecNaoOp, totDespNaoOp, totDespFin].forEach(t => {
                totFinal.total += t.total;
                t.mensal.forEach((v, i) => totFinal.mensal[i] += v);
            });

            // ------------------------------------------
            // INITIALIZE HTML
            // ------------------------------------------
            let html = `
                <style>
                    /* Reusing DRE styles */
                     .dre-month-col { min-width: 90px; text-align:right; font-size:0.8rem; }
                     .dre-row td { padding: 6px 12px; border-bottom:1px solid #e2e8f0; }
                     .dre-row:hover { background-color: #f8fafc; }
                     .row-subtotal td { background-color: #f1f5f9; font-weight: 600; padding: 8px 12px; border-top: 2px solid #e2e8f0; }
                     .row-resultado td { background-color: #e0e7ff; font-weight: 700; padding: 10px 12px; border-top: 2px solid #6366f1; color: #312e81; font-size: 0.9rem; }
                     .result-negative { color: #dc2626 !important; }
                     .result-positive { color: #166534 !important; }
                </style>
                <div style="padding:20px;">
                <h3 style="margin-bottom:20px; color:#1e293b;">DRE Gerencial Mensal - ${ano}</h3>
                <div class="dre-wrapper" style="overflow-x:auto;">
                <table class="dre-table" style="width:auto; min-width:100%;">
                    <thead>
                        <tr style="background:#f1f5f9;">
                            <th class="col-sticky col-desc">CONTA</th>
                            <th class="col-sticky col-total">TOTAL</th>
                            <th class="col-sticky col-av">AV %</th>
                            ${['JAN', 'FEV', 'MAR', 'ABR', 'MAI', 'JUN', 'JUL', 'AGO', 'SET', 'OUT', 'NOV', 'DEZ'].map(m => `<th class="dre-month-col">${m}</th>`).join('')}
                        </tr>
                    </thead>
                    <tbody>
            `;

            // ------------------------------------------
            // RENDER HELPERS
            // ------------------------------------------
            const renderTotalRow = (label, dataData, cssClass = 'row-subtotal') => {
                const av = totReceita.total ? (dataData.total / totReceita.total * 100) : 0;
                const color = dataData.total >= 0 ? 'inherit' : '#dc2626';
                const colorClass = dataData.total >= 0 ? 'result-positive' : 'result-negative';
                const finalClass = cssClass === 'row-resultado' ? (cssClass + ' ' + colorClass) : cssClass;

                html += `
                    <tr class="${finalClass}">
                        <td class="col-sticky col-desc" style="padding-left:10px;">${label}</td>
                        <td class="col-sticky col-total" style="color:${color}">${fmt(dataData.total)}</td>
                        <td class="col-sticky col-av">${av.toFixed(1)}%</td>
                         ${dataData.mensal.map(m => `<td class="dre-month-col" style="color:${m < 0 ? '#ef4444' : '#64748b'}; font-weight:700;">${fmtZero(m)}</td>`).join('')}
                    </tr>
                 `;
            };

            const renderSpace = () => html += '<tr><td colspan="15" style="height:10px;"></td></tr>';

            const renderBucket = (label, list) => {
                if (!list || list.length === 0) return;
                const visibleList = list.filter(c => {
                    const hasItems = c.itens && c.itens.length > 0;
                    if (ocultarZeros && Math.abs(c.total) < 0.01 && !hasItems) return false;
                    return true;
                });
                if (visibleList.length === 0) return;

                html += `<tr style="background:#eef2ff; font-weight:700;"><td class="col-sticky col-desc" style="color:#334155;">${label}</td><td colspan="14"></td></tr>`;

                visibleList.forEach(c => {
                    const level = c.codigo.split('.').length;
                    const indent = (level - 2) * 20 + 20;
                    const valColor = c.total < 0 ? '#dc2626' : (c.total > 0 ? '#166534' : '#64748b');
                    const av = totReceita.total ? (c.total / totReceita.total * 100) : 0;

                    html += `
                        <tr class="dre-row">
                            <td class="col-sticky col-desc" style="padding-left:${indent}px; color:#0f172a; font-weight:400;">${c.codigo} - ${c.nome}</td>
                            <td class="col-sticky col-total" style="color:${valColor}; font-weight:400;">${fmt(c.total)}</td>
                            <td class="col-sticky col-av">${av.toFixed(1)}%</td>
                             ${c.mensal.map(m => `<td class="dre-month-col" style="color:${m < 0 ? '#ef4444' : '#64748b'};">${fmtZero(m)}</td>`).join('')}
                        </tr>
                    `;
                });
            };

            // ------------------------------------------
            // RENDER OUTPUT
            // ------------------------------------------
            renderBucket('RECEITAS BRUTAS', buckets.receitas);
            renderTotalRow('(=) RECEITA BRUTA', totReceita);

            renderBucket('(-) DEDUÇÕES', buckets.deducoes);
            renderTotalRow('(=) RECEITA LÍQUIDA', totReceitaLiq);
            renderSpace();

            renderBucket('(-) CUSTOS PRODUÇÃO', buckets.custos);
            renderTotalRow('(=) LUCRO BRUTO', totLucroBruto);
            renderSpace();

            renderBucket('(-) DESPESAS OPERACIONAIS', buckets.despesasOp);
            renderTotalRow('(=) RESULTADO OPERACIONAL (EBIT)', totResOp);
            renderTotalRow('(i) EBITDA', totEBITDA, 'row-subtotal');
            renderSpace();

            renderBucket('(+) OUTRAS RECEITAS', buckets.recNaoOp);
            renderBucket('(-) OUTRAS DESPESAS', buckets.despNaoOp);
            renderBucket('(-) DESPESAS FINANCEIRAS', buckets.despFin);

            renderTotalRow('(=) RESULTADO LÍQUIDO DO EXERCÍCIO', totFinal, 'row-total row-resultado');

            html += `</tbody></table></div></div>`;
            area.innerHTML = html;
        } catch (e) {
            console.error(e);
            area.innerHTML = `<div style="color:red; padding:20px;">Erro: ${e.message}</div>`;
        }
    },

    // ============================================
    // 2. FLUXO DE CAIXA MENSAL (Novo Layout - Grade)
    // ============================================
    gerarFluxoMensal: async function (ano) {
        const area = document.getElementById('relatorio-content');
        area.innerHTML = '<div style="text-align:center; padding:50px;"><i class="fas fa-spinner fa-spin fa-2x"></i><p>Gerando Fluxo Mensal...</p></div>';

        try {
            const ocultarZeros = document.getElementById('chk-ocultar-zeros')?.checked;
            const anoInt = parseInt(ano);

            // 1. Plano Contas
            const { data: planoContas } = await window.FazendaRP.supabase.from('financeiro_plano_contas').select('*').order('codigo');

            // 0. Identificar Contas de Cartão
            const { data: ccs } = await window.FazendaRP.supabase.from('financeiro_contas').select('id').eq('tipo', 'Cartão de Crédito');
            const ccIds = (ccs || []).map(c => c.id);

            // 2. Saldo Inicial (Acumulado até 01 jan)
            const { data: dataSaldo } = await window.FazendaRP.supabase.from('financeiro_lancamentos')
                .select('valor, tipo, conta_id')
                .eq('status', 'Pago')
                .lt('data_pagamento', `${anoInt}-01-01`);

            let saldoInicialAno = 0;
            if (dataSaldo) {
                saldoInicialAno = dataSaldo.reduce((acc, m) => {
                    if (ccIds.includes(m.conta_id)) return acc;
                    return acc + (m.tipo === 'Receita' ? m.valor : -m.valor);
                }, 0);
            }

            // 3. Lancamentos do Ano
            const { data: lancs } = await window.FazendaRP.supabase.from('financeiro_lancamentos')
                .select('valor, data_pagamento, tipo, categoria, conta_id')
                .eq('status', 'Pago')
                .gte('data_pagamento', `${anoInt}-01-01`)
                .lte('data_pagamento', `${anoInt}-12-31`);

            // Estrutura
            const contaMap = {};
            planoContas.forEach(c => {
                if (c.codigo) contaMap[c.codigo] = { ...c, mensal: Array(12).fill(0), total: 0 };
            });

            // Processar
            const totaisMensais = Array(12).fill(0);

            lancs.forEach(l => {
                if (ccIds.includes(l.conta_id)) return; // Ignore CC

                if (!l.data_pagamento) return;
                const d = new Date(l.data_pagamento);
                if (d.getFullYear() !== anoInt) return;
                const mIdx = d.getUTCMonth();

                let catKey = String(l.categoria).split(' - ')[0].trim();
                let conta = contaMap[catKey];
                if (!conta) {
                    const m = planoContas.find(c => c.id == catKey || c.nome == catKey);
                    if (m) conta = contaMap[m.codigo];
                }

                let valor = this.parseCurrency(l.valor);
                let valComSinal = 0;
                if (l.tipo && (l.tipo.toLowerCase().includes('despesa') || l.tipo.toLowerCase().includes('saída'))) {
                    valComSinal = Math.abs(valor) * -1;
                } else {
                    valComSinal = Math.abs(valor);
                }

                totaisMensais[mIdx] += valComSinal;

                if (conta) {
                    conta.mensal[mIdx] += valComSinal;
                    conta.total += valComSinal;

                    let parts = conta.codigo.split('.');
                    while (parts.length > 1) {
                        parts.pop();
                        let pai = contaMap[parts.join('.')];
                        if (pai) {
                            pai.mensal[mIdx] += valComSinal;
                            pai.total += valComSinal;
                        }
                    }
                }
            });

            // Render
            const fmt2 = (v) => (Math.abs(v) < 0.01 ? '-' : v.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }));
            const meses = ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'];

            let accSaldo = saldoInicialAno;
            let htmlSaldoIni = '';
            let htmlSaldoFin = '';

            for (let i = 0; i < 12; i++) {
                htmlSaldoIni += `<td style="text-align:right; color:#64748b; background:#f8fafc; font-size:0.75rem;">${fmt2(accSaldo)}</td>`;
                accSaldo += totaisMensais[i];
                let colorFin = accSaldo >= 0 ? '#166534' : '#dc2626';
                htmlSaldoFin += `<td style="text-align:right; color:${colorFin}; font-weight:700; background:#f1f5f9;">${fmt2(accSaldo)}</td>`;
            }

            let html = `
             <div style="padding:20px;">
                <h3 style="margin-bottom:20px; color:#1e293b;">Fluxo de Caixa Mensal (Realizado) - ${anoInt}</h3>
                <div class="dre-wrapper">
                    <table class="dre-table" style="min-width: 1400px;">
                        <thead>
                            <tr>
                                <th class="col-sticky col-desc">DESCRIÇÃO</th>
                                ${meses.map(m => `<th style="text-align:right; min-width:85px;">${m}</th>`).join('')}
                                <th class="col-sticky col-total">TOTAL</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr style="font-weight:700; background:#eef2ff;">
                                <td class="col-sticky col-desc">⚡ SALDO INICIAL</td>
                                ${htmlSaldoIni}
                                <td class="col-sticky col-total">-</td>
                            </tr>
                        `;

            planoContas.forEach(c => {
                const mapped = contaMap[c.codigo];
                if (!mapped) return;
                if (ocultarZeros && Math.abs(mapped.total) < 0.01) return;

                const level = String(c.codigo).split('.').length;
                const indent = (level - 1) * 20 + 20;
                const isBold = level === 1;
                const rowStyle = isBold ? 'background-color:#f8fafc; font-weight:700;' : '';
                const colorTot = mapped.total < 0 ? '#dc2626' : (mapped.total > 0 ? '#166534' : '#334155');

                html += `<tr style="${rowStyle}">
                    <td class="col-sticky col-desc" style="padding-left:${indent}px;">${c.codigo} - ${c.nome}</td>
                    ${mapped.mensal.map(v => `<td style="text-align:right; color:${v < 0 ? '#ef4444' : (Math.abs(v) < 0.01 ? '#cbd5e1' : '#334155')}">${fmt2(v)}</td>`).join('')}
                    <td class="col-sticky col-total" style="text-align:right; color:${colorTot};">${fmt2(mapped.total)}</td>
                 </tr>`;
            });

            html += `
                            <tr style="font-weight:800; background:#0f172a; color:#fff;">
                                <td class="col-sticky col-desc" style="background:#0f172a; color:#fff;">🏁 SALDO FINAL (CAIXA)</td>
                                ${htmlSaldoFin}
                                <td class="col-sticky col-total" style="background:#0f172a; color:#4ade80;">${fmt2(accSaldo)}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>`;

            area.innerHTML = html;

        } catch (e) { console.error(e); area.innerHTML = 'Erro: ' + e.message; }
    },

    // ============================================
    // 3. FLUXO: REALIZADO vs PROJETADO (Gráfico)
    // ============================================
    gerarComparativoRealProj: async function (ano, mesInicio = null, mesFim = null) {
        const area = document.getElementById('relatorio-content');
        area.innerHTML = '<div style="text-align:center; padding:50px;"><i class="fas fa-spinner fa-spin fa-2x"></i><p>Calculando Comparativo...</p></div>';

        // Ensure ChartJS
        this.injectChartJS();

        try {
            const dataInicio = mesInicio || `${ano}-01-01`;
            const dataFim = mesFim || `${ano}-12-31`;

            // 0. Fetch Credit Card Info
            const { data: ccs } = await window.FazendaRP.supabase
                .from('financeiro_contas')
                .select('id, dia_fechamento, dia_vencimento')
                .eq('tipo', 'Cartão de Crédito');

            const ccMap = {};
            (ccs || []).forEach(c => {
                ccMap[c.id] = { diaFechamento: c.dia_fechamento || 10, diaVencimento: c.dia_vencimento || 15 };
            });
            const ccIds = Object.keys(ccMap).map(id => parseInt(id));

            // 1. Fetch Data
            const pProj = window.FazendaRP.supabase.from('financeiro_lancamentos')
                .select('valor, tipo, data_vencimento, status, conta_id')
                .neq('status', 'Cancelado')
                .gte('data_vencimento', dataInicio)
                .lte('data_vencimento', dataFim);

            const pReal = window.FazendaRP.supabase.from('financeiro_lancamentos')
                .select('valor, tipo, data_pagamento, status, conta_id')
                .eq('status', 'Pago')
                .gte('data_pagamento', dataInicio)
                .lte('data_pagamento', dataFim);

            const pSaldo = window.FazendaRP.supabase.from('financeiro_lancamentos')
                .select('valor, tipo, conta_id')
                .eq('status', 'Pago')
                .lt('data_pagamento', dataInicio);

            const [resProj, resReal, resSaldo] = await Promise.all([pProj, pReal, pSaldo]);

            // 2. Logic (Simplified from snippet for brevity but keeping core)
            const mesesList = [];
            let curr = new Date(dataInicio + 'T00:00:00');
            const endDt = new Date(dataFim + 'T00:00:00');
            curr.setDate(1); // Force 1st

            while (curr <= endDt) {
                const k = `${curr.getFullYear()}-${String(curr.getMonth() + 1).padStart(2, '0')}`;
                mesesList.push({ key: k, label: k });
                curr.setMonth(curr.getMonth() + 1);
            }

            const buckets = { proj: Array(mesesList.length).fill(0), real: Array(mesesList.length).fill(0) };

            // Populate Buckets (Real)
            (resReal.data || []).forEach(l => {
                if (ccIds.includes(l.conta_id)) return;
                const k = l.data_pagamento?.substring(0, 7);
                const idx = mesesList.findIndex(m => m.key === k);
                if (idx > -1) buckets.real[idx] += (l.tipo === 'Receita' ? l.valor : -l.valor);
            });

            // Populate Buckets (Proj)
            (resProj.data || []).forEach(l => {
                const isPending = l.status !== 'Pago';
                const isCard = l.status === 'Pago' && ccIds.includes(l.conta_id);
                if (isPending || isCard) {
                    // Simply use due date month for now (User snippet has complex CC logic, simplifying for reliability first step)
                    const k = l.data_vencimento?.substring(0, 7);
                    const idx = mesesList.findIndex(m => m.key === k);
                    if (idx > -1) buckets.proj[idx] += (l.tipo === 'Receita' ? l.valor : -l.valor);
                }
            });

            // Initial Balance
            let saldoInicial = 0;
            (resSaldo.data || []).forEach(l => {
                if (!ccIds.includes(l.conta_id)) saldoInicial += (l.tipo === 'Receita' ? l.valor : -l.valor);
            });

            // Accumulate
            const accReal = [], accProj = [];
            let rRun = saldoInicial, pRun = saldoInicial;
            for (let i = 0; i < mesesList.length; i++) {
                rRun += buckets.real[i];
                pRun += buckets.proj[i];
                accReal.push(rRun);
                accProj.push(pRun);
            }

            // Render Simple Chart Container
            area.innerHTML = `
                <div style="padding:20px; height:100%; display:flex; flex-direction:column;">
                    <h3 style="color:#1e293b;">Fluxo: Realizado vs Projetado (${ano})</h3>
                    <div style="flex:1; background:white; border-radius:8px; border:1px solid #e2e8f0; padding:20px;">
                        <canvas id="chartRealProj"></canvas>
                    </div>
                </div>
            `;

            setTimeout(() => {
                new Chart(document.getElementById('chartRealProj').getContext('2d'), {
                    type: 'line',
                    data: {
                        labels: mesesList.map(m => m.label),
                        datasets: [
                            { label: 'Realizado', data: accReal, borderColor: '#166534', backgroundColor: '#166534', tension: 0.2 },
                            { label: 'Projetado', data: accProj, borderColor: '#3b82f6', borderDash: [5, 5], tension: 0.2 }
                        ]
                    },
                    options: { responsive: true, maintainAspectRatio: false }
                });
            }, 200);

        } catch (e) { console.error(e); area.innerHTML = 'Erro: ' + e.message; }
    },

    // ============================================
    // DRE AUDITORIA (DETALHADO - MODELO EXPANSÍVEL)
    // ============================================
    gerarDREAuditoria: async function () {
        const area = document.getElementById('relatorio-content');
        area.innerHTML = '<div style="display:flex; height:100%; align-items:center; justify-content:center; color:#94a3b8;"><div style="text-align:center"><i class="fas fa-spinner fa-spin fa-2x"></i><p style="margin-top:10px">Carregando dados detalhados para auditoria...</p></div></div>';

        const ano = document.getElementById('sel-ano-rel').value;

        try {
            // 1. Fetch Data
            // Fetch Plan of Accounts
            const { data: planoContas } = await window.FazendaRP.supabase.from('financeiro_plano_contas').select('*').order('codigo');

            // Fetch Transactions (Previous Year included for safety if logic requires, but mostly current year)
            const { data: lancs } = await window.FazendaRP.supabase.from('financeiro_lancamentos')
                .select('*, parceiros(nome)')
                .neq('status', 'Cancelado')
                .gte('data_vencimento', `${Number(ano) - 1}-01-01`)
                .lte('data_vencimento', `${Number(ano) + 1}-12-31`);

            // 2. Setup Map with 'itens' array
            const contaMap = {};
            planoContas.forEach(c => {
                if (c.codigo) contaMap[c.codigo] = { ...c, total: 0, itens: [] };
            });

            // Helper for currency
            const parseCurrency = (v) => {
                if (typeof v === 'number') return v;
                if (!v) return 0;
                let str = String(v).replace(/[^\d.,-]/g, '');
                if (str.includes(',') && !str.includes('.')) str = str.replace(',', '.');
                else if (str.includes('.') && str.includes(',')) str = str.replace(/\./g, '').replace(',', '.');
                return parseFloat(str) || 0;
            };

            // 3. Processor Logic with Item Detail Capture
            // 2b. Find Special Accounts
            const findCode = (term, def) => {
                const f = planoContas.find(c => c.nome && c.nome.toLowerCase().includes(term.toLowerCase()));
                return f ? f.codigo : def;
            };
            const codeJuros = findCode('Juros', '2.4.1');
            const codeDesconto = findCode('Descontos Obtidos', '3.1.1');

            // 3. Processor Logic with Item Detail Capture
            const processar = (catRaw, valRaw, dataOp, l, itemDesc) => {
                if (!catRaw || !dataOp) return;

                // Date Check
                // dataOp string usually YYYY-MM-DD. Simple Year Check.
                const y = parseInt(dataOp.substring(0, 4));
                if (y != ano) return;

                let catKey = String(catRaw).split(' - ')[0].trim();
                let conta = contaMap[catKey];

                // Fallback: Try Name Search if ID failed
                if (!conta) {
                    const m = planoContas.find(c => c.id == catKey || c.nome == catKey);
                    if (m) conta = contaMap[m.codigo];
                }

                if (conta) {
                    let valor = parseFloat(valRaw) || 0;
                    const tipoOp = l.tipo;

                    // FORCE SIGNS for Specific Accounts
                    if (conta.codigo === codeDesconto) {
                        valor = Math.abs(valor); // Revenue/Gain = Positive
                    } else if (conta.codigo === codeJuros) {
                        valor = -Math.abs(valor); // Expense = Negative
                    } else {
                        // Standard Logic
                        if (tipoOp && (tipoOp.toLowerCase().includes('despesa') || tipoOp.toLowerCase().includes('saída'))) {
                            valor = -Math.abs(valor);
                        } else {
                            valor = Math.abs(valor);
                        }
                    }

                    // For Auditoria, we just need Total and Items list
                    conta.total += valor;

                    // Push Detail
                    conta.itens.push({
                        data: dataOp,
                        doc: l.num_doc || '-',
                        desc: itemDesc || l.descricao,
                        parceiro: (l.parceiros && l.parceiros.nome) ? l.parceiros.nome : '-',
                        valor: valor
                    });

                    // Update Parents (Recursive Bubble Up)
                    let parts = conta.codigo.split('.');
                    while (parts.length > 1) {
                        parts.pop();
                        let pai = contaMap[parts.join('.')];
                        if (pai) { pai.total += valor; }
                    }
                }
            };

            lancs.forEach(l => {
                const dataRef = l.data_emissao || l.data_vencimento; // Competência
                let det = l.detalhes;
                if (typeof det === 'string') try { det = JSON.parse(det) } catch (e) { }

                const itens = det?.itens || [];

                // Split Logic for Items
                if (itens.length > 0 && itens.some(i => i.categoria)) {
                    itens.forEach(i => {
                        const iVal = i.total || i.valor_total || (i.quantidade * i.valor_unit);
                        processar(i.categoria, iVal, dataRef, l, i.nome || i.descricao || `Item de ${l.descricao}`);
                    });

                    // Juros/Desconto also split
                    const juros = det?.juros || 0;
                    const desconto = det?.desconto || 0;
                    if (juros > 0) processar(codeJuros, juros, dataRef, l, 'Juros s/ ' + (l.descricao || 'Doc'));
                    if (desconto > 0) processar(codeDesconto, desconto, dataRef, l, 'Desconto s/ ' + (l.descricao || 'Doc'));

                } else {
                    // Whole document Logic
                    const juros = det?.juros || 0;
                    const desconto = det?.desconto || 0;
                    const valorBase = (parseFloat(l.valor) || 0) - (parseFloat(juros) || 0) + (parseFloat(desconto) || 0);

                    processar(l.categoria, valorBase, dataRef, l, l.descricao);

                    if (juros > 0) processar(codeJuros, juros, dataRef, l, 'Juros');
                    if (desconto > 0) processar(codeDesconto, desconto, dataRef, l, 'Desconto');
                }
            });

            // 4. Render Tree
            const buckets = { receitas: [], deducoes: [], custos: [], despesasOp: [], recNaoOp: [], despNaoOp: [], despFin: [], participacoes: [] };
            Object.values(contaMap).forEach(c => {
                if (!c.codigo) return;
                // Filter top levels that we render manually headers for
                if (['1', '2', '3'].includes(c.codigo)) return;

                // Assign to buckets based on prefix
                // Assign to buckets based on prefix
                if (c.codigo === codeDesconto) buckets.recNaoOp.push(c); // Always to Outras Receitas
                else if (c.codigo === codeJuros) buckets.despFin.push(c); // Always to Despesas Financeiras
                else if (c.codigo.startsWith('1')) buckets.receitas.push(c);
                else if (c.codigo.startsWith('2.6')) buckets.deducoes.push(c);
                else if (c.codigo.startsWith('2.1')) buckets.custos.push(c);
                else if (c.codigo.startsWith('2.2')) buckets.despesasOp.push(c);
                else if (c.codigo.startsWith('3')) buckets.recNaoOp.push(c);
                else if (c.codigo.startsWith('2.3')) buckets.despNaoOp.push(c);
                else if (c.codigo.startsWith('2.4')) buckets.despFin.push(c);
                else if (c.codigo.startsWith('2.5')) buckets.participacoes.push(c);
            });

            // Sort all buckets
            const sortFn = (a, b) => a.codigo.localeCompare(b.codigo, undefined, { numeric: true });
            Object.values(buckets).forEach(b => b.sort(sortFn));

            const fmt = (v) => v.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });

            let html = `
                <style>
                    .dre-tree-table { width:100%; border-collapse:collapse; font-family:'Inter', sans-serif; }
                    .dre-tree-row td { padding: 8px 12px; border-bottom:1px solid #e2e8f0; }
                    .dre-tree-row:hover { background-color: #f8fafc; cursor:pointer; }
                    .dre-cat-name { font-weight:500; display:flex; align-items:center; gap:8px; }
                    .dre-val { text-align:right; font-feature-settings:"tnum"; }
                    
                    /* Detail Table inside Row */
                    .dre-detail-row { background:#f8fafc; display:none; } /* Hidden by default */
                    .dre-detail-row.open { display:table-row; }
                    .dre-detail-container { padding: 10px 20px 20px 40px; border-bottom:1px solid #cbd5e1; }
                    .mini-table { width:100%; border:1px solid #cbd5e1; font-size:0.8rem; background:white; }
                    .mini-table th { background:#f1f5f9; text-align:left; padding:6px; font-weight:600; color:#64748b; }
                    .mini-table td { padding:6px; border-bottom:1px solid #f1f5f9; }
                </style>
                <div style="padding:20px;">
                <h3 style="margin-bottom:20px; color:#1e293b;">DRE Analítico (Auditável) - ${ano}</h3>
                <table class="dre-tree-table">
                    <thead>
                        <tr style="background:#f1f5f9; text-align:left;">
                            <th style="padding:12px; color:#64748b;">CONTA / CATEGORIA</th>
                            <th style="padding:12px; text-align:right; color:#64748b;">SALDO (R$)</th>
                        </tr>
                    </thead>
                    <tbody>
             `;

            const renderBucket = (label, list) => {
                if (!list || list.length === 0) return;

                // Filter Visible for Auditoria
                const hideZeros = document.getElementById('chk-ocultar-zeros')?.checked;

                const visibleList = list.filter(c => {
                    const hasItems = c.itens && c.itens.length > 0;
                    if (hideZeros && Math.abs(c.total) < 0.01 && !hasItems) return false;
                    return true;
                });

                if (visibleList.length === 0) return;

                html += `<tr style="background:#eef2ff; font-weight:700;"><td colspan="2" style="padding:12px; color:#334155;">${label}</td></tr>`;

                visibleList.forEach(c => {
                    // Check if it has items = Worth showing expander
                    const hasItems = c.itens && c.itens.length > 0;
                    const level = c.codigo.split('.').length;
                    const indent = (level - 2) * 20 + 10;
                    const valColor = c.total < 0 ? '#dc2626' : (c.total > 0 ? '#166534' : '#64748b');
                    const rowId = 'row-' + c.codigo.replace(/\./g, '-');

                    html += `
                        <tr class="dre-tree-row" onclick="const el = document.getElementById('${rowId}-det'); if(el) el.classList.toggle('open');">
                            <td class="dre-cat-name" style="padding-left:${indent}px; color:${hasItems ? '#0f172a' : '#475569'}; font-weight:${hasItems ? '400' : '700'};">
                                ${hasItems ? '<i class="fas fa-search-plus" style="font-size:0.7rem; color:#2563eb;"></i>' : ''}
                                ${c.codigo} - ${c.nome}
                            </td>
                            <td class="dre-val" style="color:${valColor}; font-weight:${hasItems ? '400' : '700'};">
                                ${fmt(c.total)}
                            </td>
                        </tr>
                     `;

                    // Detail Row
                    if (hasItems) {
                        const sortedItens = c.itens.sort((a, b) => new Date(a.data) - new Date(b.data));
                        html += `
                            <tr id="${rowId}-det" class="dre-detail-row">
                                <td colspan="2" class="dre-detail-container">
                                    <div style="margin-bottom:5px; font-weight:600; color:#64748b; font-size:0.8rem;">
                                        ${c.itens.length} lançamentos em: ${c.nome}
                                    </div>
                                    <table class="mini-table">
                                        <thead><tr><th>Data</th><th>Doc</th><th>Parceiro</th><th>Histórico/Item</th><th style="text-align:right">Valor</th></tr></thead>
                                        <tbody>
                                            ${sortedItens.map(i => {
                            const dFormatted = i.data ? i.data.split('-').reverse().join('/') : '-';
                            return `
                                                <tr>
                                                    <td>${dFormatted}</td>
                                                    <td>${i.doc}</td>
                                                    <td>${i.parceiro}</td>
                                                    <td>${i.desc}</td>
                                                    <td style="text-align:right; font-weight:600; color:${i.valor < 0 ? '#dc2626' : '#166534'}">${fmt(i.valor)}</td>
                                                </tr>
                                            `}).join('')}
                                        </tbody>
                                        <tfoot>
                                            <tr style="background:#f8fafc; font-weight:700;">
                                                <td colspan="4" style="text-align:right;">Subtotal</td>
                                                <td style="text-align:right;">${fmt(c.total)}</td>
                                            </tr>
                                        </tfoot>
                                    </table>
                                </td>
                            </tr>
                         `;
                    }
                });
            };

            renderBucket('RECEITAS BRUTAS', buckets.receitas);
            renderBucket('(-) DEDUÇÕES', buckets.deducoes);
            renderBucket('(-) CUSTOS PRODUÇÃO', buckets.custos);
            renderBucket('(-) DESPESAS OPERACIONAIS', buckets.despesasOp);
            renderBucket('Outras Receitas', buckets.recNaoOp);
            renderBucket('Outras Despesas', buckets.despNaoOp);
            renderBucket('Despesas Financeiras', buckets.despFin);

            html += `</tbody></table></div>`;
            area.innerHTML = html;

        } catch (error) {
            console.error(error);
            area.innerHTML = `<div style="color:red; padding:20px;">Erro ao gerar auditoria: ${error.message}</div>`;
        }
    },

    // ============================================
    // 3. REAL vs PROJETADO (Gráfico)
    // ============================================
    gerarComparativoRealProj: async function () {
        const contentDiv = document.getElementById('relatorio-content');

        // Setup Grid
        contentDiv.innerHTML = `
            <div style="padding:20px; height:100%; display:flex; flex-direction:column;">
                <h3 style="margin-top:0; color:#334155;">Comparativo: Realizado vs Projetado</h3>
                <div style="flex:1; position:relative;">
                    <canvas id="chartRelComparativo"></canvas>
                </div>
            </div>
        `;

        const ctx = document.getElementById('chartRelComparativo').getContext('2d');

        // Mock Data for Prototype
        const labels = ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'];

        new Chart(ctx, {
            type: 'bar',
            data: {
                labels: labels,
                datasets: [
                    {
                        label: 'Projetado (Orçamento)',
                        data: [100, 100, 100, 120, 120, 120, 150, 150, 150, 180, 180, 200],
                        backgroundColor: '#cbd5e1',
                        borderRadius: 4
                    },
                    {
                        label: 'Realizado',
                        data: [95, 105, 98, 130, 115, 0, 0, 0, 0, 0, 0, 0],
                        backgroundColor: '#3b82f6',
                        borderRadius: 4
                    }
                ]
            },
            options: {
                responsive: true,
                maintainAspectRatio: false,
                plugins: {
                    title: { display: false }
                },
                scales: {
                    y: { beginAtZero: true }
                }
            }
        });
    },

    // ============================================
    // 5. RESULTADO POR SAFRA (Detalhado)
    // ============================================
    gerarResultadoSafra: async function () {
        const area = document.getElementById('relatorio-content');
        const safraId = document.getElementById('sel-safra-filtro') ? document.getElementById('sel-safra-filtro').value : null;

        if (!safraId) {
            area.innerHTML = '<div style="text-align:center; padding:50px; color:#64748b;">Selecione uma Safra para visualizar o resultado.</div>';
            return;
        }

        area.innerHTML = '<div style="text-align:center; padding:50px;"><i class="fas fa-spinner fa-spin fa-2x"></i><p>Calculando Resultado da Safra...</p></div>';

        try {
            const { data: safra } = await window.FazendaRP.supabase.from('safras').select('*').eq('id', safraId).single();
            if (!safra) throw new Error("Safra não encontrada");

            // 1. Fetch Data
            const { data: planoContas } = await window.FazendaRP.supabase.from('financeiro_plano_contas').select('*').order('codigo');

            // Fetch ALL transactions safely to parse rateio? Or try to filter?
            // Rateio is inside JSON. Supabase filtering on JSON arrays is hard.
            // Fetch active transactions.
            const { data: lancs } = await window.FazendaRP.supabase.from('financeiro_lancamentos')
                .select('*, parceiros(nome)')
                .neq('status', 'Cancelado');

            // 2. Setup Map
            const contaMap = {};
            planoContas.forEach(c => {
                if (c.codigo) contaMap[c.codigo] = { ...c, total: 0, itens: [] };
            });

            // 3. Process Logic
            const processar = (catRaw, valRaw, dataOp, l, itemDesc) => {
                // Ensure value is for THIS safra via Rateio Logic 
                // This function is called AFTER rateio validation usually.
                // But here we need to validate rateio inside.
                // Actually, the caller should calculate the 'valRaw' as the PROPORTIONAL value for this safra.

                if (!catRaw) return;

                let catKey = String(catRaw).split(' - ')[0].trim();
                let conta = contaMap[catKey];
                if (!conta) {
                    const m = planoContas.find(c => c.id == catKey || c.nome == catKey);
                    if (m) conta = contaMap[m.codigo];
                }

                if (conta) {
                    let valor = valRaw; // Already signed/calculated by caller

                    // Sign logic: If expense, negative.
                    const tipoOp = l.tipo;
                    if (tipoOp && (tipoOp.toLowerCase().includes('despesa') || tipoOp.toLowerCase().includes('saída'))) {
                        // Ensure it's negative
                        if (valor > 0) valor = -valor;
                    } else {
                        // Ensure it's positive
                        if (valor < 0) valor = Math.abs(valor);
                    }

                    conta.total += valor;
                    conta.itens.push({
                        data: dataOp,
                        doc: l.num_doc || '-',
                        desc: itemDesc,
                        parceiro: (l.parceiros && l.parceiros.nome) ? l.parceiros.nome : '-',
                        valor: valor
                    });

                    // Parents
                    let parts = conta.codigo.split('.');
                    while (parts.length > 1) {
                        parts.pop();
                        let pai = contaMap[parts.join('.')];
                        if (pai) { pai.total += valor; }
                    }
                }
            };

            const parseMoney = (v) => {
                if (typeof v === 'number') return v;
                if (typeof v === 'string') return parseFloat(v.replace(/[^\d.,-]/g, '').replace(',', '.')) || 0;
                return 0;
            };

            lancs.forEach(l => {
                // 1. Check Document Level Rateio
                let docRateios = [];
                if (l.rateio) {
                    try {
                        const r = typeof l.rateio === 'string' ? JSON.parse(l.rateio) : l.rateio;
                        if (Array.isArray(r)) docRateios = r;
                        else if (r) docRateios = [r];
                    } catch (e) { }
                }
                // Also check detalhe.rateio
                let det = l.detalhes;
                if (typeof det === 'string') try { det = JSON.parse(det) } catch (e) { }

                if (det?.rateio) { // Legacy/Simple
                    if (Array.isArray(det.rateio)) docRateios = docRateios.concat(det.rateio);
                }

                const docSafraMatches = docRateios.filter(r => String(r.safra_id) === String(safraId));

                // 2. Check Item Level Rateio
                const itens = det?.itens || [];

                // STRATEGY: 
                // A) If Items exist, iterate items. If item has rateio, use it. If item has NO rateio, check Ref Doc Rateio? Or assume 100%?
                // Usually logic: Item Rateio > Doc Rateio.

                if (itens.length > 0 && itens.some(i => i.categoria)) {
                    itens.forEach(i => {
                        let iRateios = [];
                        if (i.rateio) {
                            if (Array.isArray(i.rateio)) iRateios = i.rateio;
                            // else if object?
                        } else if (docSafraMatches.length > 0) {
                            // Property distribution from Doc? Only if item doesn't specify.
                            // Complex. Let's assume if item doesn't have rateio, it doesn't belong to safra UNLESS doc has strictly 1 safra?
                            // Safest: Use Doc Matches proportional?
                            // Let's stick to: If Item has rateio, use it. If not, ignore item for safra specific report to avoid false positives?
                            // OR: If Doc has 100% to Safra X, apply to all items?
                            // Let's use Matches found in Doc level if Item level is empty.
                            iRateios = docSafraMatches;
                        }

                        // Filter for current safra
                        const matches = iRateios.filter(r => String(r.safra_id) === String(safraId));
                        if (matches.length > 0) {
                            // Sum value for this safra
                            let valSafra = matches.reduce((acc, r) => acc + parseMoney(r.valor), 0);
                            const iTotal = i.total || i.valor_total || (i.quantidade * i.valor_unit) || 0;
                            // Sanity check: if rateio is %, calc value. But usually stored as value R$.
                            // If sum is 0, maybe it's percentage based? (Not standard in this system yet).

                            if (valSafra !== 0) {
                                processar(i.categoria, valSafra, l.data_vencimento, l, i.nome || i.descricao);
                            }
                        }
                    });

                    // Juros/Desconto logic? Apply proportional to Safra?
                    // Skipping complexity for now.
                } else {
                    // No Items (Simple Launch)
                    if (docSafraMatches.length > 0) {
                        let valSafra = docSafraMatches.reduce((acc, r) => acc + parseMoney(r.valor), 0);
                        if (valSafra !== 0) {
                            processar(l.categoria, valSafra, l.data_vencimento, l, l.descricao);
                        }
                    }
                }
            });

            // 4. Render
            const buckets = { receitas: [], deducoes: [], custos: [], despesasOp: [], recNaoOp: [], despNaoOp: [], despFin: [], participacoes: [] };
            Object.values(contaMap).forEach(c => {
                if (!c.codigo) return;
                if (['1', '2', '3'].includes(c.codigo)) return;
                if (c.codigo.startsWith('1')) buckets.receitas.push(c);
                else if (c.codigo.startsWith('2.6')) buckets.deducoes.push(c);
                else if (c.codigo.startsWith('2.1')) buckets.custos.push(c);
                else if (c.codigo.startsWith('2.2')) buckets.despesasOp.push(c);
                else if (c.codigo.startsWith('3')) buckets.recNaoOp.push(c);
                else if (c.codigo.startsWith('2.3')) buckets.despNaoOp.push(c);
                else if (c.codigo.startsWith('2.4')) buckets.despFin.push(c);
                else if (c.codigo.startsWith('2.5')) buckets.participacoes.push(c);
            });
            const sortFn = (a, b) => a.codigo.localeCompare(b.codigo, undefined, { numeric: true });
            Object.values(buckets).forEach(b => b.sort(sortFn));

            const fmt = (v) => v.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });

            let html = `
                <style>
                     .dre-tree-row:hover { background-color: #f8fafc; cursor:pointer; }
                     .dre-detail-row { background:#f8fafc; display:none; }
                     .dre-detail-row.open { display:table-row; }
                     .mini-table { width:100%; border:1px solid #cbd5e1; font-size:0.8rem; background:white; }
                </style>
                <div style="padding:20px;">
                <h3 style="margin-bottom:20px; color:#1e293b;">Resultado da Safra: ${safra.descricao} (${safra.ano})</h3>
                <div class="dre-wrapper">
                <table class="dre-table" style="width:100%;">
                    <thead>
                        <tr>
                            <th class="col-sticky col-desc">CONTA</th>
                            <th class="col-sticky col-total">TOTAL</th>
                            <th class="col-sticky col-av">AV %</th>
                        </tr>
                    </thead>
                    <tbody>`;

            const getTot = (code) => contaMap[code] ? contaMap[code].total : 0;
            const totalRec = getTot('1');

            const renderBucket = (label, list) => {
                if (!list || list.length === 0) return;
                html += `<tr style="background:#eef2ff; font-weight:700;"><td class="col-sticky col-desc" style="color:#334155;">${label}</td><td colspan="2"></td></tr>`;

                list.forEach(c => {
                    const hasItems = c.itens && c.itens.length > 0;
                    if (Math.abs(c.total) < 0.01 && !hasItems) return;

                    const level = c.codigo.split('.').length;
                    const indent = (level - 2) * 20 + 20;
                    const valColor = c.total < 0 ? '#dc2626' : (c.total > 0 ? '#166534' : '#64748b');
                    const rowId = 'saf-' + c.codigo.replace(/\./g, '-');
                    const av = totalRec ? (c.total / totalRec * 100) : 0;

                    html += `
                        <tr class="dre-tree-row" onclick="const el = document.getElementById('${rowId}-det'); if(el) el.classList.toggle('open');">
                            <td class="col-sticky col-desc" style="padding-left:${indent}px; color:${hasItems ? '#0f172a' : '#475569'}; font-weight:${hasItems ? '400' : '700'};">
                                ${hasItems ? '<i class="fas fa-search-plus" style="font-size:0.7rem; color:#2563eb;"></i>' : ''}
                                ${c.codigo} - ${c.nome}
                            </td>
                            <td class="col-sticky col-total" style="color:${valColor}; font-weight:${hasItems ? '400' : '700'};">${fmt(c.total)}</td>
                            <td class="col-sticky col-av">${av.toFixed(1)}%</td>
                        </tr>
                    `;

                    if (hasItems) {
                        const sortedItens = c.itens.sort((a, b) => new Date(b.data) - new Date(a.data));
                        html += `
                            <tr id="${rowId}-det" class="dre-detail-row">
                                <td colspan="3" style="padding:10px 20px;">
                                    <div style="font-weight:600; color:#64748b; font-size:0.8rem; margin-bottom:5px;">
                                        Detalhes: ${c.nome}
                                    </div>
                                    <table class="mini-table">
                                        <thead><tr><th>Data</th><th>Doc</th><th>Parceiro</th><th>Histórico</th><th style="text-align:right">Valor</th></tr></thead>
                                        <tbody>
                                            ${sortedItens.map(i => `
                                                <tr>
                                                    <td>${i.data.split('-').reverse().join('/')}</td>
                                                    <td>${i.doc}</td>
                                                    <td>${i.parceiro}</td>
                                                    <td>${i.desc}</td>
                                                    <td style="text-align:right; font-weight:600; color:${i.valor < 0 ? '#dc2626' : '#166534'}">${fmt(i.valor)}</td>
                                                </tr>
                                            `).join('')}
                                        </tbody>
                                    </table>
                                </td>
                            </tr>
                         `;
                    }

                });
            };

            renderBucket('RECEITAS BRUTAS', buckets.receitas);
            renderBucket('(-) DEDUÇÕES', buckets.deducoes);
            renderBucket('(-) CUSTOS PRODUÇÃO', buckets.custos);
            renderBucket('(-) DESPESAS OPERACIONAIS', buckets.despesasOp);
            renderBucket('Outras Receitas', buckets.recNaoOp);
            renderBucket('Outras Despesas', buckets.despNaoOp);
            renderBucket('Despesas Financeiras', buckets.despFin);

            html += `</tbody></table></div></div>`;
            area.innerHTML = html;

        } catch (e) {
            console.error(e);
            area.innerHTML = 'Erro: ' + e.message;
        }
    },

    // ============================================
    // 4. COMPARATIVO ANUAL
    // ============================================
    gerarComparativoAnual: async function () {
        const area = document.getElementById('relatorio-content');
        area.innerHTML = '<div style="text-align:center; padding:50px;"><i class="fas fa-spinner fa-spin fa-2x"></i><p>Gerando Comparativo...</p></div>';

        const ano = document.getElementById('sel-ano-rel').value;

        try {
            const ocultarZeros = document.getElementById('chk-ocultar-zeros') ? document.getElementById('chk-ocultar-zeros').checked : true;
            const anoAtual = parseInt(ano);
            const anoAnt = anoAtual - 1;

            // 1. Plano Contas
            const { data: planoContas } = await window.FazendaRP.supabase.from('financeiro_plano_contas').select('*').order('codigo');

            // 2. Lancamentos (2 anos)
            const { data: lancs } = await window.FazendaRP.supabase.from('financeiro_lancamentos')
                .select('valor, data_vencimento, data_emissao, tipo, categoria, detalhes')
                .neq('status', 'Cancelado')
                .gte('data_vencimento', `${anoAnt}-01-01`)
                .lte('data_vencimento', `${anoAtual}-12-31`);

            // Estrutura
            const contaMap = {};
            planoContas.forEach(c => {
                if (c.codigo) contaMap[c.codigo] = { ...c, totalAtual: 0, totalAnt: 0 };
            });

            // Processar
            lancs.forEach(l => {
                const dt = l.data_vencimento || l.data_emissao;
                if (!dt) return;
                const dObj = new Date(dt);
                // Timezone Correction
                const userTimezoneOffset = dObj.getTimezoneOffset() * 60000;
                const correctedDate = new Date(dObj.getTime() + userTimezoneOffset);

                const y = correctedDate.getFullYear();
                if (y !== anoAtual && y !== anoAnt) return;

                let catKey = String(l.categoria).split(' - ')[0].trim();
                let conta = contaMap[catKey];
                if (!conta) {
                    const m = planoContas.find(c => c.id == catKey || c.nome == catKey);
                    if (m) conta = contaMap[m.codigo];
                }

                if (conta) {
                    let valor = this.parseCurrency(l.valor);
                    if (l.tipo && (l.tipo.toLowerCase().includes('despesa') || l.tipo.toLowerCase().includes('saída'))) {
                        valor = Math.abs(valor) * -1;
                    } else {
                        valor = Math.abs(valor);
                    }

                    if (y === anoAtual) conta.totalAtual += valor;
                    else conta.totalAnt += valor;

                    // Pai
                    let parts = conta.codigo.split('.');
                    while (parts.length > 1) {
                        parts.pop();
                        let pai = contaMap[parts.join('.')];
                        if (pai) {
                            if (y === anoAtual) pai.totalAtual += valor;
                            else pai.totalAnt += valor;
                        }
                    }
                }
            });

            // Render
            const fmt = (v) => v.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });

            let html = `
                <div style="padding:20px;">
                <h3 style="margin-bottom:20px; color:#1e293b;">Comparativo Contábil (${anoAnt} vs ${anoAtual})</h3>
                <div class="dre-wrapper">
                    <table class="dre-table">
                        <thead>
                            <tr>
                                <th class="col-sticky col-desc">DESCRIÇÃO</th>
                                <th style="text-align:right;">${anoAnt}</th>
                                <th style="text-align:right;">${anoAtual}</th>
                                <th style="text-align:right;">DIFERENÇA ($)</th>
                                <th style="text-align:right;">DIFERENÇA (%)</th>
                            </tr>
                        </thead>
                        <tbody>`;

            // Ordenar e filtrar
            const sortedKeys = Object.keys(contaMap).sort((a, b) => a.localeCompare(b, undefined, { numeric: true }));

            sortedKeys.forEach(k => {
                const mapped = contaMap[k];
                if (!mapped) return;
                if (ocultarZeros && Math.abs(mapped.totalAtual) < 0.01 && Math.abs(mapped.totalAnt) < 0.01) return;

                const diffVal = mapped.totalAtual - mapped.totalAnt;
                const diffPct = (mapped.totalAnt !== 0) ? ((diffVal / Math.abs(mapped.totalAnt)) * 100).toFixed(1) + '%' : '-';

                const level = String(mapped.codigo).split('.').length;
                const indent = (level - 1) * 20 + 20;
                const isBold = level === 1; // Raiz em negrito
                const rowStyle = isBold ? 'background-color:#f8fafc; font-weight:700;' : '';

                const colorDiff = diffVal > 0 ? '#166534' : (diffVal < 0 ? '#dc2626' : '#64748b');

                html += `<tr style="${rowStyle}">
                    <td class="col-sticky col-desc" style="padding-left:${indent}px;">${mapped.codigo} - ${mapped.nome}</td>
                    <td style="text-align:right;">${fmt(mapped.totalAnt)}</td>
                    <td style="text-align:right;">${fmt(mapped.totalAtual)}</td>
                    <td style="text-align:right; color:${colorDiff}; font-weight:600;">${fmt(diffVal)}</td>
                    <td style="text-align:right; color:${colorDiff};">${diffPct}</td>
                    </tr>`;
            });

            html += `</tbody></table></div></div>`;
            area.innerHTML = html;

        } catch (e) { console.error(e); area.innerHTML = 'Erro: ' + e.message; }
    },
    // ============================================
    // 4. LIVRO CAIXA (EXTRATO)
    // ============================================
    gerarLivroCaixa: async function (inicio, fim, contaId = '') {
        const area = document.getElementById('relatorio-content');
        area.innerHTML = '<div style="text-align:center; padding:50px;"><i class="fas fa-spinner fa-spin fa-2x"></i><p>Gerando Livro Caixa (Movimentações)...</p></div>';

        try {
            // 1. Saldo Anterior (Soma de movimentações anteriores)
            let qSaldo = window.FazendaRP.supabase.from('financeiro_movimentacoes')
                .select('valor, tipo')
                .lt('data_operacao', inicio);

            if (contaId) qSaldo = qSaldo.eq('conta_id', contaId);
            const rSaldo = await qSaldo;

            let saldoAnt = 0;
            if (rSaldo.data) {
                rSaldo.data.forEach(m => {
                    const val = typeof m.valor === 'number' ? m.valor : parseFloat(m.valor);
                    saldoAnt += (m.tipo === 'CREDITO' || m.tipo === 'Receita') ? Math.abs(val) : -Math.abs(val);
                });
            }

            // 2. Movimentações do Período
            let qMov = window.FazendaRP.supabase.from('financeiro_movimentacoes')
                .select('*, financeiro_lancamentos(descricao, categoria, parceiros(nome)), financeiro_contas(nome)')
                .gte('data_operacao', inicio)
                .lte('data_operacao', fim)
                .order('data_operacao', { ascending: true });

            if (contaId) qMov = qMov.eq('conta_id', contaId);
            const { data: movs, error } = await qMov;

            if (error) throw error;

            // Render
            const fmt = (v) => v.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
            let html = `
                <div style="padding:20px;">
                    <div style="display:flex; justify-content:space-between; align-items:center; margin-bottom:20px;">
                         <h3 style="margin:0; color:#1e293b;">Livro Caixa / Extrato: ${inicio.split('-').reverse().join('/')} a ${fim.split('-').reverse().join('/')}</h3>
                         <button class="btn-report" onclick="window.print()"><i class="fas fa-print"></i> PDF</button>
                    </div>
                    
                    <div style="background:#f8fafc; padding:15px; border-radius:8px; margin-bottom:20px; font-weight:bold; border:1px solid #e2e8f0; display:flex; justify-content:space-between;">
                        <span>Saldo Anterior:</span>
                        <span style="color:${saldoAnt >= 0 ? '#166534' : '#dc2626'}">R$ ${fmt(saldoAnt)}</span>
                    </div>

                    <div class="dre-wrapper" style="box-shadow:none; border:1px solid #e2e8f0; border-radius:8px;">
                        <table class="dre-table">
                            <thead>
                                <tr style="background:#f1f5f9; color:#64748b;">
                                    <th style="padding:12px;">DATA</th>
                                    <th style="text-align:left; padding:12px;">DESCRIÇÃO / HISTÓRICO</th>
                                    <th style="text-align:left; padding:12px;">PARCEIRO</th>
                                    <th style="text-align:left; padding:12px;">CONTA</th>
                                    <th style="text-align:right; padding:12px;">ENTRADA</th>
                                    <th style="text-align:right; padding:12px;">SAÍDA</th>
                                    <th style="text-align:right; padding:12px;">SALDO</th>
                                </tr>
                            </thead>
                            <tbody>
            `;

            let acumulado = saldoAnt;
            let totalEntradas = 0;
            let totalSaidas = 0;

            if (!movs || movs.length === 0) {
                html += `<tr><td colspan="7" style="text-align:center; padding:20px; color:#94a3b8;">Nenhuma movimentação neste período.</td></tr>`;
            } else {
                movs.forEach(m => {
                    const isCredito = (m.tipo === 'CREDITO' || m.tipo === 'Receita');
                    const absVal = Math.abs(parseFloat(m.valor || 0));

                    if (isCredito) {
                        acumulado += absVal;
                        totalEntradas += absVal;
                    } else {
                        acumulado -= absVal;
                        totalSaidas += absVal;
                    }

                    // Infos
                    // Priorizamos descricao do lancamento pai, senao historico da mov
                    let desc = m.historico || 'Sem Descrição';
                    let parc = '-';
                    if (m.financeiro_lancamentos) {
                        if (m.financeiro_lancamentos.descricao) desc = m.financeiro_lancamentos.descricao;
                        if (m.financeiro_lancamentos.parceiros && m.financeiro_lancamentos.parceiros.nome) {
                            parc = m.financeiro_lancamentos.parceiros.nome;
                        }
                    }
                    if (m.financeiro_contas && m.financeiro_contas.nome) {
                        // Se filtramos por conta, isso é redundante, mas util se for "Todas"
                    }

                    const corSal = acumulado >= 0 ? '#166534' : '#dc2626';

                    html += `
                        <tr style="border-bottom:1px solid #f1f5f9;">
                            <td style="padding:10px 12px; color:#64748b;">${m.data_operacao.split('-').reverse().join('/')}</td>
                            <td style="text-align:left; padding:10px 12px; font-weight:500; color:#334155;">${desc}</td>
                            <td style="text-align:left; padding:10px 12px; color:#64748b;">${parc}</td>
                            <td style="text-align:left; padding:10px 12px; color:#64748b; font-size:0.8rem;">${m.financeiro_contas?.nome || '-'}</td>
                            
                            <td style="text-align:right; padding:10px 12px; color:#166534; background:${isCredito ? '#f0fdf4' : 'transparent'};">
                                ${isCredito ? fmt(absVal) : '-'}
                            </td>
                            <td style="text-align:right; padding:10px 12px; color:#dc2626; background:${!isCredito ? '#fef2f2' : 'transparent'};">
                                ${!isCredito ? fmt(absVal) : '-'}
                            </td>
                            <td style="text-align:right; padding:10px 12px; font-weight:700; color:${corSal};">
                                ${fmt(acumulado)}
                            </td>
                        </tr>
                    `;
                });
            }

            const resultadoPeriodo = totalEntradas - totalSaidas;

            html += `
                            </tbody>
                            <tfoot>
                                <tr style="background:#e2e8f0; font-weight:800; color:#1e293b;">
                                    <td colspan="4" style="text-align:right; padding:15px;">TOTAIS DO PERÍODO:</td>
                                    <td style="text-align:right; padding:15px; color:#166534;">${fmt(totalEntradas)}</td>
                                    <td style="text-align:right; padding:15px; color:#dc2626;">${fmt(totalSaidas)}</td>
                                    <td style="text-align:right; padding:15px; color:${resultadoPeriodo >= 0 ? '#166534' : '#dc2626'}; font-size:1.1rem;">${fmt(resultadoPeriodo)}</td>
                                </tr>
                            </tfoot>
                        </table>
                    </div>
                </div>
            `;
            area.innerHTML = html;

        } catch (e) {
            console.error('Erro gerarLivroCaixa', e);
            area.innerHTML = '<div style="color:red; padding:20px;">Erro: ' + e.message + '</div>';
        }
    },

    // ============================================
    // 5. FLUXO DIÁRIO HÍBRIDO (Realizado vs Previsto)
    // ============================================
    gerarFluxoCaixa: async function (inicio, fim, contaId = '') {
        const area = document.getElementById('relatorio-content');
        area.innerHTML = '<div style="text-align:center; padding:50px;"><i class="fas fa-spinner fa-spin fa-2x"></i><p>Calculando Fluxo de Caixa Híbrido...</p></div>';
        this.injectChartJS();

        try {
            // 1. SALDO INICIAL REAL (Via Movimentações)
            // Busca tudo antes de 'inicio' para compor o Saldo de Partida
            let qSaldo = window.FazendaRP.supabase.from('financeiro_movimentacoes')
                .select('valor, tipo')
                .lt('data_operacao', inicio);

            if (contaId) qSaldo = qSaldo.eq('conta_id', contaId);
            const { data: movsAnt, error: errSaldo } = await qSaldo;
            if (errSaldo) throw errSaldo;

            let saldoInicial = 0;
            if (movsAnt) {
                movsAnt.forEach(m => {
                    const val = parseFloat(m.valor || 0);
                    const tipo = (m.tipo || '').toUpperCase();
                    // Lógica de Sinal: Créditos somam, Débitos subtraem
                    if (tipo.includes('CREDITO') || tipo.includes('RECEITA') || tipo.includes('ENTRADA')) {
                        saldoInicial += Math.abs(val);
                    } else {
                        saldoInicial -= Math.abs(val);
                    }
                });
            }

            // 2. REALIZADO (Período) via Movimentações
            let qReal = window.FazendaRP.supabase.from('financeiro_movimentacoes')
                .select('data_operacao, valor, tipo, historico, conta_id')
                .gte('data_operacao', inicio)
                .lte('data_operacao', fim);
            if (contaId) qReal = qReal.eq('conta_id', contaId);
            const { data: movsReal } = await qReal;

            // 3. PREVISTO (Período) via Lançamentos (Apenas Pendentes/Agendados)
            let qPrev = window.FazendaRP.supabase.from('financeiro_lancamentos')
                .select('data_vencimento, valor, tipo, descricao, status')
                .neq('status', 'Pago')
                .neq('status', 'Cancelado')
                .gte('data_vencimento', inicio)
                .lte('data_vencimento', fim);
            if (contaId) qPrev = qPrev.eq('conta_id', contaId);
            const { data: lancsPrev } = await qPrev;

            // 4. MERGE TIMELINE
            const timeline = {};

            const addDay = (dateStr, val, tipoOrigem, desc, isPrev) => {
                if (!dateStr) return;
                const dia = dateStr.split('T')[0];
                if (!timeline[dia]) timeline[dia] = { in: 0, out: 0, items: [] };

                const absVal = Math.abs(parseFloat(val || 0));
                let isEntrada = false;
                const t = (tipoOrigem || '').toUpperCase();

                // Detectar Entrada
                if (t.includes('RECEITA') || t.includes('CREDITO') || t.includes('ENTRADA')) isEntrada = true;

                if (isEntrada) timeline[dia].in += absVal;
                else timeline[dia].out += absVal;

                timeline[dia].items.push({
                    desc,
                    val: (isEntrada ? absVal : -absVal),
                    tipo: isPrev ? 'prev' : 'real'
                });
            };

            // Add Real
            (movsReal || []).forEach(m => addDay(m.data_operacao, m.valor, m.tipo, m.historico || 'Movimentação', false));

            // Add Prev
            (lancsPrev || []).forEach(l => addDay(l.data_vencimento, l.valor, l.tipo, (l.descricao || 'Lançamento Futuro'), true));

            // 5. Build Chart Data (Continuous Days)
            const startD = new Date(inicio);
            const endD = new Date(fim);

            const labels = [];
            const dataSaldo = [];

            // Tabela Data (Sparse is fine)
            const tableRows = [];

            let currentSaldo = saldoInicial;
            const fmt = (v) => v.toLocaleString('pt-BR', { minimumFractionDigits: 2 });

            // Iterar todos os dias para o gráfico
            for (let d = new Date(startD); d <= endD; d.setDate(d.getDate() + 1)) { // Modify d in place
                const dayStr = d.toISOString().split('T')[0];
                const dayData = timeline[dayStr];

                let diaIn = 0;
                let diaOut = 0;

                if (dayData) {
                    diaIn = dayData.in;
                    diaOut = dayData.out;
                    // Salva para tabela
                    tableRows.push({
                        date: dayStr,
                        in: diaIn,
                        out: diaOut,
                        saldo: currentSaldo + diaIn - diaOut // End of day balance
                    });
                }

                currentSaldo += (diaIn - diaOut);

                labels.push(dayStr.split('-').reverse().slice(0, 2).join('/'));
                dataSaldo.push(currentSaldo);
            }

            // 6. RENDER
            area.innerHTML = `
                 <div style="padding:20px; height:100%; display:flex; flex-direction:column;">
                     <h3 style="color:#1e293b;">Fluxo Diário: ${inicio.split('-').reverse().join('/')} a ${fim.split('-').reverse().join('/')}</h3>
                     
                     <div style="height:300px; background:white; border:1px solid #e2e8f0; border-radius:8px; padding:10px; margin-bottom:20px;">
                         <canvas id="chartFluxoDiario"></canvas>
                     </div>

                     <div class="dre-wrapper" style="flex:1;">
                        <table class="dre-table">
                            <thead>
                                <tr><th>DATA</th><th style="text-align:right">ENTRADAS</th><th style="text-align:right">SAÍDAS</th><th style="text-align:right">SALDO ACUM.</th></tr>
                            </thead>
                            <tbody>
                                <tr style="background:#f1f5f9; font-weight:bold;">
                                    <td>SALDO INICIAL</td>
                                    <td>-</td>
                                    <td>-</td>
                                    <td style="text-align:right; color:${saldoInicial >= 0 ? '#166534' : '#dc2626'}">${fmt(saldoInicial)}</td>
                                </tr>
                                ${tableRows.length === 0
                    ? '<tr><td colspan="4" style="text-align:center; padding:15px; color:#94a3b8;">Nenhuma movimentação</td></tr>'
                    : tableRows.map(r => `
                                    <tr>
                                        <td style="text-align:left;">${r.date.split('-').reverse().join('/')}</td>
                                        <td style="text-align:right; color:#166534;">${r.in > 0 ? fmt(r.in) : '-'}</td>
                                        <td style="text-align:right; color:#dc2626;">${r.out > 0 ? fmt(r.out) : '-'}</td>
                                        <td style="text-align:right; font-weight:bold; color:${r.saldo >= 0 ? '#0f172a' : '#dc2626'}">${fmt(r.saldo)}</td>
                                    </tr>
                                `).join('')}
                            </tbody>
                        </table>
                     </div>
                 </div>
             `;

            setTimeout(() => {
                new Chart(document.getElementById('chartFluxoDiario').getContext('2d'), {
                    type: 'line',
                    data: {
                        labels: labels,
                        datasets: [{
                            label: 'Saldo Acumulado (R$)',
                            data: dataSaldo,
                            borderColor: '#2563eb',
                            backgroundColor: 'rgba(37,99,235,0.1)',
                            borderWidth: 2,
                            pointRadius: 1, // Cleaner look
                            fill: true,
                            tension: 0.1
                        }]
                    },
                    options: {
                        responsive: true,
                        maintainAspectRatio: false,
                        interaction: { intersect: false, mode: 'index' },
                        plugins: {
                            tooltip: { callbacks: { label: (ctx) => 'Saldo: ' + fmt(ctx.raw) } }
                        }
                    }
                });
            }, 200);

        } catch (e) { console.error(e); area.innerHTML = 'Erro: ' + e.message; }
    },

    // ============================================
    // 6. RESULTADOS POR SAFRA
    // ============================================
    gerarResultadoSafra: async function (safraId = null) {
        console.log('gerarResultadoSafra called', { safraId });

        // If no ID, check filter
        if (!safraId) safraId = document.getElementById('sel-safra-filtro')?.value;
        const area = document.getElementById('relatorio-content');

        if (!safraId) {
            area.innerHTML = '<div style="padding:50px; text-align:center; color:#64748b;">Selecione uma Safra para visualizar os resultados.</div>';
            return;
        }

        area.innerHTML = '<div style="text-align:center; padding:50px;"><i class="fas fa-spinner fa-spin fa-2x"></i><p>Calculando Resultado da Safra...</p></div>';

        try {
            const ocultarZeros = document.getElementById('chk-ocultar-zeros')?.checked;

            // 1. Dados Safra (Titulo)
            const { data: safra } = await window.FazendaRP.supabase.from('safras').select('*').eq('id', safraId).single();
            const tituloSafra = safra ? `${safra.descricao} (${safra.ano})` : 'Safra Desconhecida';

            // 2. Plano Contas
            const { data: planoContas } = await window.FazendaRP.supabase.from('financeiro_plano_contas').select('*').order('codigo');

            // 3. Lancamentos com Rateio
            // Buscamos tudo que não é cancelado (Competência)
            // IMPORTANTE: Buscamos detalhes onde o rateio está armazenado
            const { data: lancs, error } = await window.FazendaRP.supabase.from('financeiro_lancamentos')
                .select('detalhes, categoria, tipo, valor')
                .neq('status', 'Cancelado');

            if (error) {
                console.error("Erro na busca de lançamentos:", error);
                area.innerHTML = `<div style="color:red; padding:20px; text-align:center;">Erro ao buscar dados: ${error.message}</div>`;
                return;
            }

            console.log("DEBUG: Safra Selecionada:", safraId);
            console.log("DEBUG: Lançamentos Totais Busca:", lancs ? lancs.length : 0);

            // Estrutura
            const contaMap = {};
            (planoContas || []).forEach(c => {
                if (c.codigo) contaMap[c.codigo] = { ...c, total: 0 };
            });

            // Processar
            let totalReceita = 0;
            let totalDespesa = 0;
            let countProcessados = 0;

            (lancs || []).forEach(l => {
                // Coletar todos os rateios possíveis
                let allRateios = [];

                // 1. Rateio na coluna raiz (se existir/legado)
                if (l.rateio) {
                    let r = l.rateio;
                    if (typeof r === 'string') try { r = JSON.parse(r); } catch (e) { }
                    if (Array.isArray(r)) allRateios.push(...r);
                    else if (typeof r === 'object') allRateios.push(r);
                }

                // 2. Rateio em detalhes (Simples e Com Itens)
                if (l.detalhes) {
                    // Caso simples: detalhes.rateio
                    if (l.detalhes.rateio && Array.isArray(l.detalhes.rateio)) {
                        allRateios.push(...l.detalhes.rateio);
                    }
                    // Caso itens: detalhes.itens[].rateio
                    if (l.detalhes.itens && Array.isArray(l.detalhes.itens)) {
                        l.detalhes.itens.forEach(item => {
                            if (item.rateio && Array.isArray(item.rateio)) {
                                allRateios.push(...item.rateio);
                            }
                        });
                    }
                }

                if (allRateios.length === 0) return;

                // Filtrar apenas o rateio para a safra atual e somar
                const targetSafraId = String(safraId);
                let somaValorSafra = 0;
                let encontrou = false;

                allRateios.forEach(r => {
                    // Comparação frouxa string vs int
                    if (String(r.safra_id) === targetSafraId) {
                        // Parse Valor
                        let val = 0;
                        if (typeof r.valor === 'number') val = r.valor;
                        else if (typeof r.valor === 'string') {
                            val = parseFloat(r.valor.replace(/[^\d,-]/g, '').replace(',', '.')) || 0;
                        }
                        somaValorSafra += val;
                        encontrou = true;
                    }
                });

                if (!encontrou || Math.abs(somaValorSafra) < 0.01) return;

                countProcessados++;

                // Mapear Conta
                let catKey = String(l.categoria).split(' - ')[0].trim();
                let conta = contaMap[catKey];
                // Fallback pelo nome se codigo não bater
                if (!conta) {
                    const m = planoContas.find(c => c.id == catKey || c.nome == catKey);
                    if (m) conta = contaMap[m.codigo];
                }

                // Sinal base pelo TIPO do lançamento
                let valComSinal = somaValorSafra;
                if (l.tipo && (l.tipo.toLowerCase().includes('despesa') || l.tipo.toLowerCase().includes('saída'))) {
                    valComSinal = -Math.abs(somaValorSafra);
                    totalDespesa += Math.abs(somaValorSafra);
                } else {
                    valComSinal = Math.abs(somaValorSafra);
                    totalReceita += Math.abs(somaValorSafra);
                }

                if (conta) {
                    conta.total += valComSinal;
                    // Subir valores para Pais
                    let parts = conta.codigo.split('.');
                    while (parts.length > 1) {
                        parts.pop();
                        let pai = contaMap[parts.join('.')];
                        if (pai) { pai.total += valComSinal; }
                    }
                }
            });

            console.log("DEBUG: Itens Processados para Safra:", countProcessados);

            if (countProcessados === 0) {
                area.innerHTML = `
                    <div style="padding:20px;">
                        <h2 style="color:#1e293b; margin-bottom:10px;">Resultados: ${tituloSafra}</h2>
                        <div style="background:#fef2f2; border:1px solid #fecaca; color:#991b1b; padding:20px; border-radius:8px; text-align:center; margin-top:20px;">
                            <i class="fas fa-exclamation-triangle fa-2x" style="margin-bottom:10px;"></i><br>
                            Nenhum lançamento com rateio foi encontrado para esta safra.<br>
                            <span style="font-size:0.85rem; color:#64748b;">(Total analisado no banco: ${lancs ? lancs.length : 0} lançamentos)</span>
                        </div>
                    </div>`;
                return;
            }

            const resultado = totalReceita - totalDespesa;
            const margem = totalReceita > 0 ? (resultado / totalReceita) * 100 : 0;
            const fmt = (v) => v.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });

            area.innerHTML = `
                 <div style="padding:20px;">
                    <div style="display:flex; justify-content:space-between; align-items:center; margin-bottom:20px;">
                        <h2 style="color:#1e293b; margin:0;">Resultados: ${tituloSafra}</h2>
                        <div style="text-align:right;">
                            <span style="font-size:0.85rem; color:#64748b;">Margem Líquida</span>
                            <div style="font-weight:700; color:${margem >= 0 ? '#166534' : '#dc2626'}; font-size:1.4rem;">${margem.toFixed(1)}%</div>
                        </div>
                    </div>
                    
                    <div style="display:grid; grid-template-columns:repeat(3,1fr); gap:20px; margin-bottom:30px;">
                        <div class="kpi-card" style="background:#f0fdf4; border-left:4px solid #22c55e; padding:20px; border-radius:8px;">
                            <div style="font-size:0.9rem; color:#15803d;">Receita Total</div>
                            <div style="font-size:1.5rem; font-weight:700; color:#166534;">${fmt(totalReceita)}</div>
                        </div>
                        <div class="kpi-card" style="background:#fef2f2; border-left:4px solid #ef4444; padding:20px; border-radius:8px;">
                            <div style="font-size:0.9rem; color:#b91c1c;">Despesa Total</div>
                            <div style="font-size:1.5rem; font-weight:700; color:#dc2626;">${fmt(totalDespesa)}</div>
                        </div>
                        <div class="kpi-card" style="background:${resultado >= 0 ? '#f0fdf4' : '#fef2f2'}; border-left:4px solid ${resultado >= 0 ? '#22c55e' : '#ef4444'}; padding:20px; border-radius:8px;">
                            <div style="font-size:0.9rem; color:#334155;">Resultado Líquido</div>
                            <div style="font-size:1.5rem; font-weight:700; color:${resultado >= 0 ? '#166534' : '#dc2626'};">${fmt(resultado)}</div>
                        </div>
                    </div>

                    <div class="dre-wrapper" style="border-radius:8px; border:1px solid #e2e8f0;">
                        <table class="dre-table">
                            <thead><tr><th>CONTA / CATEGORIA</th><th style="text-align:right">VALOR</th><th style="text-align:right">AV %</th></tr></thead>
                            <tbody>
                                ${Object.values(contaMap)
                    .filter(c => Math.abs(c.total) >= 0.01)
                    .sort((a, b) => a.codigo.localeCompare(b.codigo, undefined, { numeric: true }))
                    .map(c => {
                        const level = String(c.codigo).split('.').length;
                        const indent = (level - 1) * 20 + 20;
                        const isBold = level === 1;
                        const rowStyle = isBold ? 'background-color:#f8fafc; font-weight:700;' : '';
                        const colorTot = c.total < 0 ? '#dc2626' : (c.total > 0 ? '#166534' : '#334155');
                        const av = totalReceita > 0 ? (c.total / totalReceita) * 100 : 0;

                        return `
                                            <tr style="${rowStyle}">
                                                <td style="text-align:left; padding-left:${indent}px;">${c.codigo} - ${c.nome}</td>
                                                <td style="color:${colorTot}; text-align:right;">${fmt(c.total)}</td>
                                                <td style="text-align:right; color:#64748b;">${av.toFixed(1)}%</td>
                                            </tr>
                                        `;
                    }).join('')}
                            </tbody>
                        </table>
                    </div>
                 </div>
             `;

        } catch (e) {
            console.error('Erro gerarResultadoSafra', e);
            area.innerHTML = 'Erro: ' + e.message;
        }
    },

    // ============================================
    // 7. COMPARATIVO ANUAL (Tab DRE)
    // ============================================
    gerarComparativoAnual: async function (ano) {
        const area = document.getElementById('relatorio-content');
        area.innerHTML = '<div style="text-align:center; padding:50px;"><i class="fas fa-spinner fa-spin fa-2x"></i><p>Gerando Comparativo Anual...</p></div>';

        try {
            const anoInt = parseInt(ano);
            const anoAnt = anoInt - 1;

            // 1. Fetch Plano de Contas Separately (Join correction)
            const { data: planoContas } = await window.FazendaRP.supabase.from('financeiro_plano_contas').select('*');
            const pcMap = {};
            (planoContas || []).forEach(p => {
                pcMap[p.id] = p; // Map by ID
                if (p.nome) pcMap[p.nome] = p; // Fallback Map by Name
            });

            // 2. Fetch Transactions (Current & Previous) - REMOVED JOIN
            const q1 = window.FazendaRP.supabase.from('financeiro_lancamentos')
                .select('valor, tipo, data_pagamento, categoria')
                .eq('status', 'Pago')
                .gte('data_pagamento', `${anoInt}-01-01`)
                .lte('data_pagamento', `${anoInt}-12-31`);

            const q2 = window.FazendaRP.supabase.from('financeiro_lancamentos')
                .select('valor, tipo, data_pagamento, categoria')
                .eq('status', 'Pago')
                .gte('data_pagamento', `${anoAnt}-01-01`)
                .lte('data_pagamento', `${anoAnt}-12-31`);

            const [r1, r2] = await Promise.all([q1, q2]);

            // 3. Process Logic
            const contaMap = {};

            const process = (rows, isCurrent) => {
                rows.forEach(l => {
                    // Resolve Category/Account
                    // 'categoria' col might be ID or Name.
                    let catKey = l.categoria;
                    let plano = pcMap[catKey];

                    // Fallback logic similar to DRE
                    if (!plano && typeof catKey === 'string' && catKey.includes(' - ')) {
                        const splitKey = catKey.split(' - ')[0].trim();
                        plano = pcMap[splitKey] || Object.values(pcMap).find(p => p.codigo === splitKey);
                    }

                    let codigo = plano ? plano.codigo : '9.9.9';
                    let nome = plano ? plano.nome : (typeof catKey === 'string' ? catKey : 'Não Classificado');

                    // If still no code, try to group by name
                    if (codigo === '9.9.9' && nome !== 'Não Classificado') {
                        // Maybe it's a legacy category name
                        codigo = 'EXT';
                    }

                    if (!contaMap[codigo]) contaMap[codigo] = { codigo, nome, totalAtual: 0, totalAnt: 0 };

                    const val = (l.tipo === 'Receita' ? l.valor : -l.valor);
                    if (isCurrent) contaMap[codigo].totalAtual += val;
                    else contaMap[codigo].totalAnt += val;
                });
            };

            process(r1.data || [], true);
            process(r2.data || [], false);

            // Render
            const fmt = (v) => v.toLocaleString('pt-BR', { minimumFractionDigits: 2 });
            const sortedKeys = Object.keys(contaMap).sort();

            let html = `
                 <div style="padding:20px;">
                    <h3>Comparativo Anual: ${anoAnt} vs ${anoInt}</h3>
                    <div class="dre-wrapper">
                        <table class="dre-table">
                            <thead>
                                <tr>
                                    <th style="text-align:left;">CONTA</th>
                                    <th>${anoAnt}</th>
                                    <th>${anoInt}</th>
                                    <th>DIFERENÇA (R$)</th>
                                    <th>VARIAÇÃO (%)</th>
                                </tr>
                            </thead>
                            <tbody>
             `;

            sortedKeys.forEach(k => {
                const c = contaMap[k];
                const diff = c.totalAtual - c.totalAnt;
                const pct = c.totalAnt !== 0 ? ((diff / Math.abs(c.totalAnt)) * 100).toFixed(1) + '%' : '-';
                const color = diff >= 0 ? '#166534' : '#dc2626';

                html += `
                     <tr>
                         <td style="text-align:left;">${c.codigo} - ${c.nome}</td>
                         <td>${fmt(c.totalAnt)}</td>
                         <td>${fmt(c.totalAtual)}</td>
                         <td style="color:${color}; font-weight:600;">${fmt(diff)}</td>
                         <td style="color:${color};">${pct}</td>
                     </tr>
                 `;
            });

            html += `</tbody></table></div></div>`;
            area.innerHTML = html;

        } catch (e) { console.error(e); area.innerHTML = 'Erro: ' + e.message; }
    },

    // ============================================
    // 8. REALIZADO VS PROJETADO (Dinâmico)
    // ============================================
    gerarComparativoRealProj: async function () {
        const area = document.getElementById('relatorio-content');
        area.innerHTML = '<div style="text-align:center; padding:50px;"><i class="fas fa-spinner fa-spin fa-2x"></i><p>Gerando Comparativo Dinâmico (Real vs Proj)...</p></div>';

        const mesInicio = document.getElementById('rel-mes-inicio')?.value;
        const mesFim = document.getElementById('rel-mes-fim')?.value;

        if (!mesInicio || !mesFim) {
            area.innerHTML = '<div style="padding:50px; text-align:center;">Selecione o período (Mês/Ano).</div>';
            return;
        }

        try {
            // 1. Build Month List (Columns)
            const mesesList = [];
            let curr = new Date(mesInicio + '-01T00:00:00');
            const end = new Date(mesFim + '-01T00:00:00');

            // Corrige timezone offset para nao pular dia
            const toLocal = (d) => new Date(d.getTime() + d.getTimezoneOffset() * 60000);

            // Safety cap: 36 months
            let safety = 0;
            while (curr <= end && safety < 36) {
                const y = curr.getFullYear();
                const m = curr.getMonth() + 1;
                const key = `${y}-${String(m).padStart(2, '0')}`;
                // Capitalizar Mes
                const label = curr.toLocaleDateString('pt-BR', { month: 'short', year: '2-digit' }).replace('.', '').toUpperCase();
                mesesList.push({ key, label, valReal: 0, valProj: 0, accReal: 0, accProj: 0 });
                curr.setMonth(curr.getMonth() + 1);
                safety++;
            }

            if (mesesList.length === 0) throw new Error("Intervalo inválido.");

            // 2. Fetch Data
            // Realizado (Movimentações)
            const startDate = mesInicio + '-01';
            // Last day of end month
            const endDateObj = new Date(mesFim + '-01T00:00:00');
            endDateObj.setMonth(endDateObj.getMonth() + 1);
            endDateObj.setDate(0);
            const endDate = endDateObj.toISOString().split('T')[0];

            const qReal = window.FazendaRP.supabase.from('financeiro_movimentacoes')
                .select('data_operacao, valor, tipo')
                .gte('data_operacao', startDate)
                .lte('data_operacao', endDate);

            const qProj = window.FazendaRP.supabase.from('financeiro_lancamentos')
                .select('data_vencimento, valor, tipo, status')
                .neq('status', 'Pago')
                .neq('status', 'Cancelado')
                .gte('data_vencimento', startDate)
                .lte('data_vencimento', endDate);

            const [resReal, resProj] = await Promise.all([qReal, qProj]);

            // 3. Populate Buckets

            // Real (Movimentacoes)
            (resReal.data || []).forEach(m => {
                const k = m.data_operacao.substring(0, 7); // YYYY-MM
                const idx = mesesList.findIndex(x => x.key === k);
                if (idx >= 0) {
                    const val = parseFloat(m.valor || 0);
                    // Lógica: Crédito/Receita = Positivo, Débito/Despesa = Negativo
                    // Para fins de gráfico de FLUXO: Entrada aumenta saldo, Saida diminui.
                    let net = 0;
                    const t = (m.tipo || '').toUpperCase();
                    if (t.includes('CREDITO') || t.includes('RECEITA') || t.includes('ENTRADA')) net = Math.abs(val);
                    else net = -Math.abs(val);

                    mesesList[idx].valReal += net;
                }
            });

            // Proj (Lancamentos Abertos)
            (resProj.data || []).forEach(l => {
                const k = l.data_vencimento.substring(0, 7);
                const idx = mesesList.findIndex(x => x.key === k);
                if (idx >= 0) {
                    const val = parseFloat(l.valor || 0);
                    let net = (l.tipo === 'Receita') ? Math.abs(val) : -Math.abs(val);
                    mesesList[idx].valProj += net;
                }
            });

            // 4. Calculate Accumulators
            let accReal = 0;
            let accProj = 0;

            mesesList.forEach(m => {
                accReal += m.valReal;
                accProj += m.valProj;

                m.accReal = accReal;
                m.accProj = accProj;
            });

            // 5. Render
            const fmt = (v) => v.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });

            area.innerHTML = `
                 <div style="padding:20px; height:100%; display:flex; flex-direction:column;">
                     <h3 style="color:#1e293b;">Fluxo Realizado vs Projetado (${mesesList[0].label} a ${mesesList[mesesList.length - 1].label})</h3>
                     <div style="height:350px; background:white; border:1px solid #e2e8f0; border-radius:8px; padding:10px; margin-bottom:20px;">
                         <canvas id="chartComp"></canvas>
                     </div>
                     <div class="dre-wrapper" style="flex:1;">
                         <table class="dre-table">
                             <thead>
                                 <tr>
                                     <th rowspan="2" style="text-align:left;">MÊS</th>
                                     <th colspan="2" style="text-align:center; color:#166534; border-bottom:1px solid #cbd5e1;">REALIZADO</th>
                                     <th colspan="2" style="text-align:center; color:#2563eb; border-bottom:1px solid #cbd5e1;">PROJETADO (Em Aberto)</th>
                                 </tr>
                                 <tr>
                                     <th style="text-align:right;">MENSAL</th>
                                     <th style="text-align:right;">ACUMULADO</th>
                                     <th style="text-align:right;">MENSAL</th>
                                     <th style="text-align:right;">ACUMULADO</th>
                                 </tr>
                             </thead>
                             <tbody>
                                 ${mesesList.map(m => `
                                     <tr>
                                         <td style="text-align:left;">${m.label}</td>
                                         <td style="color:#166534;">${fmt(m.valReal)}</td>
                                         <td style="font-weight:bold; color:#166534;">${fmt(m.accReal)}</td>
                                         <td style="color:#2563eb;">${fmt(m.valProj)}</td>
                                         <td style="font-weight:bold; color:#2563eb;">${fmt(m.accProj)}</td>
                                     </tr>
                                 `).join('')}
                             </tbody>
                         </table>
                     </div>
                 </div>
             `;

            setTimeout(() => {
                new Chart(document.getElementById('chartComp').getContext('2d'), {
                    type: 'line',
                    data: {
                        labels: mesesList.map(m => m.label),
                        datasets: [
                            {
                                label: 'Realizado (Acum)',
                                data: mesesList.map(m => m.accReal),
                                borderColor: '#166534',
                                backgroundColor: 'rgba(22, 101, 52, 0.1)',
                                fill: true, tension: 0.3
                            },
                            {
                                label: 'Projetado (Acum)',
                                data: mesesList.map(m => m.accProj),
                                borderColor: '#2563eb',
                                backgroundColor: 'rgba(37, 99, 235, 0.1)',
                                borderDash: [5, 5],
                                fill: true, tension: 0.3
                            }
                        ]
                    },
                    options: { maintainAspectRatio: false, responsive: true }
                });
            }, 200);

        } catch (e) { console.error(e); area.innerHTML = 'Erro: ' + e.message; }
    },

}; // End of Relatorios Object
